/* CHANGE LOG BY DEVESH 2026-10-07: products tagged ab-hide (A/B PDP copies, handle <original>-2) are skipped in this listing — they show on their own PDP only. */
/* build: 2026-09-18T13:00 find-your-size size bar */
/* SHOP ALL WOMEN 3 — engine (assets/saw3.js). Built by scripts/build_saw3.py from the v2 engine.
   CHANGE LOG BY DEVESH 2026-09-16: template-1 speed fork — static asset (cached), no roundel rail, no
   quick-add / size-chart / gender popup / Discover / swatch list, ncp3-style cards with colour + size on
   the media, Fit / Fabric chip rail under the toggles, localStorage catalogue cache, slimmer GraphQL query.
   Per-section config (the only Liquid the old snippet needed) arrives in window.__saw3Cfg[sid]. */
/* CHANGE LOG BY DEVESH 2026-09-17: size filter is multi-select (filterState.size is an array); price
   supports multi-select bands read from data-price-bands on the section root. */
/* CHANGE LOG BY DEVESH 2026-09-17: cards prefer each product's own review numbers
   (custom.review_rating / review_count) over the grouped loox.* family values. */
/* CHANGE LOG BY DEVESH 2026-09-17: compact snapshot-first loading, abortable fallback,
   preserve filters during stock refresh, and avoid redundant row replacement. */
(function () {
function saw3Engine(root, cfg) {
  var SID    = cfg.sid;
  var TOKEN  = '388bd37219d8ab7daee1c58a23c03cc8';
  var API    = cfg.api;
  var inr = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 });
  var CAT_ORDER   = cfg.catOrder || '';
  var CAT_HIDE = (function () {
    var out = {};
    String(cfg.catHide || '').split('\n').forEach(function (s) {
      var k = s.trim().toLowerCase().replace(/[^a-z0-9]/g, '');
      if (k) out[k] = 1;
    });
    return out;
  })();
  /* 2026-09-25: product-code tag → lifestyle photo (cfg.lifestyle, built in Liquid from each code's collection
     custom.lifestyle_image). A grid tile opens on it; the colour frames follow on swipe. Empty map = off. */
  var LIFESTYLE = cfg.lifestyle || {};
  function lifestyleOf(list) {
    for (var i = 0; i < list.length; i++) { var t = list[i].tags || []; for (var j = 0; j < t.length; j++) if (LIFESTYLE[t[j]]) return LIFESTYLE[t[j]]; }
    return '';
  }
  function catHidden(label) { return !!CAT_HIDE[String(label || '').toLowerCase().replace(/[^a-z0-9]/g, '')]; }
  var ROUNDEL_FIT = 'cover';
  var LAYOUT = root.getAttribute('data-layout') === 'grid' ? 'grid' : 'rows';
  var BENTO = root.getAttribute('data-bento') === '1';   /* grid variant whose phone layout interlocks tall/short tiles */

  function qs(s, c) { return (c || document).querySelector(s); }
  function qsa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function id(suffix) { return document.getElementById(suffix + '-' + SID); }
  function slugify(s) { return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') || 'cat'; }
  function parseGids(val) { if (!val) return []; try { var a = JSON.parse(val); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  // category = product title minus gender prefix minus colour name (e.g. "Men Yellow Airy Linen Short Kurta" -> "Airy Linen Short Kurta")
  function deriveCatLabel(title, color) {
    var s = (title || '').replace(/\b(women's|men's|womens|mens|women|men|unisex)\b/gi, ' ');
    if (color) { var c = color.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); s = s.replace(new RegExp('\\b' + c + '\\b', 'i'), ' '); }
    return s.replace(/\s+/g, ' ').trim();
  }

  var sizeOrderMap = { 'XXS':1,'XS':2,'S':3,'M':4,'L':5,'XL':6,'2XL':7,'3XL':8,'4XL':9,'5XL':10 };

  var WOMEN_COLL = root.getAttribute('data-women-collection') || '';
  var MEN_COLL   = root.getAttribute('data-men-collection') || '';
  var WOMEN_TOP  = (root.getAttribute('data-women-top-tag')    || 'Women Topwear').toLowerCase().trim();
  var WOMEN_BOT  = (root.getAttribute('data-women-bottom-tag') || 'Women Bottomwear').toLowerCase().trim();
  var MEN_TOP    = (root.getAttribute('data-men-top-tag')      || 'Men Topwear').toLowerCase().trim();
  var MEN_BOT    = (root.getAttribute('data-men-bottom-tag')   || 'Men Bottomwear').toLowerCase().trim();
  var currentGender = 'women';
  var COLLECTION = '', TOP_TAG = '', BOT_TAG = '';
  function setGenderVars(g) {
    currentGender = (g === 'men') ? 'men' : 'women';
    if (currentGender === 'men') { COLLECTION = MEN_COLL; TOP_TAG = MEN_TOP; BOT_TAG = MEN_BOT; }
    else { COLLECTION = WOMEN_COLL; TOP_TAG = WOMEN_TOP; BOT_TAG = WOMEN_BOT; }
  }
  setGenderVars('women');
  var CAT_KEY    = root.getAttribute('data-cat-key') || 'category_filter_name';
  var IMG_KEY    = root.getAttribute('data-img-key') || 'category_filter_image';
  var CAT_SOURCE = root.getAttribute('data-cat-source') || 'metafield';
  var COMPARE_MULT = parseFloat(root.getAttribute('data-compare-mult')) || 2;
  var LAUNCH_PRICES = {};   // code (lowercase) -> rupees; display-only launch price override (gap-twill convention)
  (root.getAttribute('data-launch-prices') || '').split('\n').forEach(function (ln) {
    var lm = ln.split(':'); if (lm.length < 2) return;
    var lc = lm[0].trim().toLowerCase(), lv = parseFloat(lm[1]);
    if (lc && lv > 0) LAUNCH_PRICES[lc] = lv;
  });
  var SHOW_TITLE = root.getAttribute('data-show-title') === 'true';
  var MAX        = parseInt(root.getAttribute('data-max'), 10) || 400;
  var STOCK_FILTER = root.getAttribute('data-stock-filter') === 'true';
  var MIN_INV    = parseInt(root.getAttribute('data-min-inv'), 10) || 15;
  var RATE       = 0.40;        // colour gate 2026-08-13: hide a colour only when 60%+ of its size SKUs are OOS (in-stock ratio must EXCEED 40%)
  /* 2026-09-18: "Find Your Size" is a size-led page, so a style that is down to two
     sizes is exactly what a shopper hunting their size wants to see. data-partial-sizes
     drops the ratio gate to "at least one size in stock". Opt-in: templates 3/4/5/6
     keep the 40% rule. The Step-1 filter still requires skuGt0 > 0, so nothing that is
     entirely out of stock gets through. */
  if (root.getAttribute('data-partial-sizes') === '1') RATE = 0;
  /* 2026-09-25: data-broken-sizes="1" inverts the colour gate for the broken-size page: keep a colour only
     when HALF OR MORE of its sizes are out of stock but at least one is still in stock (fully sold-out
     colours stay hidden — nothing to buy). Opt-in; every other template keeps the rule above. */
  var BROKEN_SIZES = root.getAttribute('data-broken-sizes') === '1';
  /* 2026-09-25: floating SIZE | WOMEN | MEN | FILTER bar + first-visit gender/size popup (data-ffbar="1"), ported
     from shop-all-campaign3 for a mixed Women + Men catalogue (Broken Sizes). Gender is the ffGender filter over the
     one loaded catalogue, so switching is instant; the layout stays this engine's. */
  var FFBAR = root.getAttribute('data-ffbar') === '1';
  /* 2026-10-03: gender sub-pages (Shop All Shirts…): one mixed catalogue served at BOTH the men and the women
     collection URL (data-ff-men-handle / data-ff-women-handle). The URL (or ?gender=) picks the gender; the
     WOMEN / MEN chip swaps the address bar to the sibling collection, so reload/share keep the gender.
     The all-gender collection (source) always opens the gender popup; the Men / Women URLs never do. */
  var FF_HANDLES = { men: root.getAttribute('data-ff-men-handle') || '', women: root.getAttribute('data-ff-women-handle') || '' };
  var FF_PAGES = FFBAR && !!(FF_HANDLES.men || FF_HANDLES.women);
  /* 2026-10-03: single-gender sub-pages (Tops / Dresses = women, Jackets = men) set only one handle: every URL opens on
     that gender, no popup, and the other gender's chip is hidden. */
  var FF_ONLY = FF_PAGES && !(FF_HANDLES.men && FF_HANDLES.women) ? (FF_HANDLES.men ? 'men' : 'women') : '';
  function ffUrlGender() {
    var g = (new URLSearchParams(location.search).get('gender') || '').toLowerCase();
    if (g === 'men' || g === 'women') return g;
    var h = (location.pathname.split('/collections/')[1] || '').split('/')[0];
    return h && h === FF_HANDLES.men ? 'men' : h && h === FF_HANDLES.women ? 'women' : FF_ONLY;
  }
  function ffSwapUrl(g) {
    if (!FF_PAGES || !FF_HANDLES[g]) return;
    var q = new URLSearchParams(location.search); q.delete('gender');
    var qs = q.toString();
    try { history.replaceState(history.state, '', location.pathname.split('/collections/')[0] + '/collections/' + FF_HANDLES[g] + (qs ? '?' + qs : '') + location.hash); } catch (e) {}
    document.title = document.title.replace(/\b(Women|Men)\b/, g === 'men' ? 'Men' : 'Women');
  }
  /* 2026-09-25: data-healthy-sizes="1" — the inverse of broken sizes: keep a colour only when MORE than half of its
     sizes are in stock (4 of 8 stays on Broken Sizes only, so no colour is on both pages). */
  var HEALTHY_SIZES = root.getAttribute('data-healthy-sizes') === '1';
  /* 2026-10-01: data-new-tag="<tag>" (New Color Launch): products carrying the tag lead their category, wear the
     data-new-badge label and skip the stock gates (pre-launch colours have 0 stock) with every size listed. */
  var NEW_TAG = (root.getAttribute('data-new-tag') || '').toLowerCase().trim();
  var NEW_BADGE = root.getAttribute('data-new-badge') || 'NEW COLOR';
  /* 2026-09-25: data-row-limit="N" (rails): each category carousel shows its top N by best seller (then stock) and
     View All opens the NEXT one (N+1), hidden when there is none. Explore More is never limited. */
  var ROW_LIMIT = parseInt(root.getAttribute('data-row-limit'), 10) || 0;
  var COLOR_KEY  = root.getAttribute('data-color-key') || 'product_variants';
  var STEP2_AVG_MIN = 15;       // Step 2 (colour gate): a colour's average size qty must be > 15  (fixed in code)
  var SORT_BEST  = root.getAttribute('data-sort-best') !== 'false';   // rank categories by best sellers
  /* 2026-10-02 opt-in (data-score-sort="1", Shop All Men Shirts 2): categories AND colours ranked by
     0.7 × 30-day units ÷ max + 0.3 × stock ÷ max — the drawer rule (scripts/nav_rank.py). Units come from the
     catalogue snapshot (scripts/saw3_catalog.py --units); the live refresh keeps them via UNITS30. */
  var SCORE_SORT = root.getAttribute('data-score-sort') === '1';
  var UNITS30 = {};

  var gridEl     = document.getElementById('saw-grid-' + SID);

  var allProducts = {};      // handle -> product
  var categories  = [];      // { key, label, slug, image, hasTop, hasBottom, products[], roundelEl, rowEl, trackEl }
  var LOCK_GROUP = (root.getAttribute('data-lock-group') || '').trim();   // 2026-08-14: '' | 'top' | 'bottom' — locks the page to one group (topwear/bottomwear templates)
  /* 2026-08-17: deep links — ?group=topwear|bottomwear picks the wear group, ?ctog=<toggle> picks
     the category toggle (composes with ?category= for the tile) */
  var URL_GROUP = (function () {
    try {
      var q = new URLSearchParams(location.search);
      var g = (q.get('women_category') || q.get('group') || '').toLowerCase().trim();
      if (g === 'top' || g === 'topwear' || g === 'tops') return 'top';
      if (g === 'bottom' || g === 'bottomwear' || g === 'bottoms') return 'bottom';
    } catch (e) {}
    return null;
  })();
  var URL_CTOG = (function () {
    try {
      var q = new URLSearchParams(location.search);
      return ((q.get('ctoggle') || q.get('ctog') || '')).toLowerCase().replace(/[^a-z0-9]/g, '');
    } catch (e) { return ''; }
  })();
  var activeGroup = LOCK_GROUP || URL_GROUP || null;    // null | 'top' | 'bottom'
  /* 2026-08-17: category toggle rail (Tops / Bottoms / Kurtas…) — keyword-mapped groups of the
     tile categories. One group active at a time; tiles + zones outside it hide (specials stay). */
  var CAT_TOGGLES = root.getAttribute('data-cat-toggles') === 'true';
  var SHOW_COLOUR_COUNT = root.getAttribute('data-colour-count') !== 'false';
  var catGroups = (root.getAttribute('data-cat-groups') || '').split('\n').map(function (l) {
    var ci = l.indexOf(':'); if (ci < 0) return null;
    return { label: l.slice(0, ci).trim(),
             kws: l.slice(ci + 1).split(',').map(function (k) { return k.trim().toLowerCase(); }).filter(Boolean) };
  }).filter(function (g) { return g && g.label && g.kws.length; });
  var catGroupsLive = [];      // groups that actually have categories this render
  var activeCatTog = null, tempCatTog = null, urlTogApplied = false, userTogChosen = false, pinnedTog = null;
  var spyHold = false;         // ?category= target fully OOS: group selected, no tile until first scroll
  function groupOfLabel(lbl) {
    lbl = String(lbl || '').toLowerCase();
    var best = null, bestLen = 0;   // longest matching keyword wins: 't-shirt' beats 'shirt' beats 'top'
    catGroups.forEach(function (g) {
      g.kws.forEach(function (k) { if (k.length > bestLen && lbl.indexOf(k) !== -1) { best = g.label; bestLen = k.length; } });
    });
    return best || 'More';
  }
  function assignCatTogGroups() {
    if (!CAT_TOGGLES) return;
    var buckets = {};
    catGroups.forEach(function (g) { buckets[g.label] = { label: g.label, cats: [], img: '' }; });
    buckets['More'] = { label: 'More', cats: [], img: '' };
    categories.forEach(function (cat) {
      if (cat.special || cat.noTile) { cat.tGroup = null; return; }
      if (activeGroup && !(activeGroup === 'top' ? cat.hasTop : cat.hasBottom)) { cat.tGroup = null; return; }   // ?women_category= scopes the toggles
      if (ffGender && !cat.products.some(function (p) { return prodGender(p) === ffGender; })) { cat.tGroup = null; return; }   // gender chip: drop toggles with nothing for this gender
      var gl = groupOfLabel(cat.label);
      cat.tGroup = gl;
      buckets[gl].cats.push(cat);
      /* 2026-09-25: with a gender chosen (floating-bar pages) the pill shows that gender's first product —
         a category shared by Women and Men could put a man on the Shirts pill of the Women view. */
      var gFirst = ffGender ? cat.products.filter(function (p) { return prodGender(p) === ffGender; })[0] : null;
      if (!buckets[gl].img) buckets[gl].img = (gFirst && gFirst.image) || cat.image;
    });
    catGroupsLive = catGroups.map(function (g) { return buckets[g.label]; })
      .concat([buckets['More']])
      .filter(function (b) { return b.cats.length > 0; });   // empty groups (e.g. no Pants) skip themselves
    /* 2026-08-17: toggle order follows sales — the group holding the best-selling product leads;
       the More catch-all always trails */
    catGroupsLive.forEach(function (b) {
      var best = Infinity;
      b.cats.forEach(function (c) { if (typeof c.bestRank === 'number' && c.bestRank < best) best = c.bestRank; });
      b.bestRank = best;
    });
    catGroupsLive.sort(function (a, b2) {
      if ((a.label === 'More') !== (b2.label === 'More')) return a.label === 'More' ? 1 : -1;
      return a.bestRank - b2.bestRank;
    });
    if (URL_CTOG && !userTogChosen) {
      var hitTog = null;
      catGroupsLive.forEach(function (b3) { if (!hitTog && b3.label.toLowerCase().replace(/[^a-z0-9]/g, '') === URL_CTOG) hitTog = b3.label; });
      if (hitTog) { activeCatTog = hitTog; userTogChosen = true; }
    }
    if (!urlTogApplied && URL_CAT) {
      /* streaming arrives best-sellers-first, so a brand-new category lands in a LATE batch —
         keep retrying each batch; the flag only flips once a pick actually lands (or the
         stream ends). The old code flipped it on the FIRST batch and never matched new launches. */
      var hit = null;
      categories.forEach(function (cat) { if (!hit && (normCat(cat.slug) === URL_CAT || normCat(cat.label) === URL_CAT)) hit = cat; });
      if (hit && hit.tGroup) { activeCatTog = hit.tGroup; userTogChosen = true; urlTogApplied = true; }
      else if (fetchComplete) {   // fully OOS/absent even after the whole stream — settle for its group
        urlTogApplied = true;
        var gl2 = groupOfLabel(URL_CAT.replace(/-/g, ' '));
        if (catGroupsLive.some(function (b) { return b.label === gl2; })) { activeCatTog = gl2; spyHold = true; userTogChosen = true; }
      }
    }
    if (!userTogChosen || !catGroupsLive.some(function (b) { return b.label === activeCatTog; })) {
      // streaming fetch: early batches may miss the first group entirely (best sellers arrive first),
      // so keep re-defaulting to the FIRST live group until the user actively picks one
      if (!userTogChosen) activeCatTog = catGroupsLive.length ? catGroupsLive[0].label : null;
      else activeCatTog = catGroupsLive.length ? catGroupsLive[0].label : null;
    }
    /* A deep-linked toggle LEADS the rail. The sort above orders by sales, which on
       ?ctoggle=shirts put Shirts third — far enough right that a phone shows it off-screen and
       the link looks like it did nothing. Pinned once, from the URL-driven pick only: the pin
       survives the streaming re-runs of this function, and a later tap never re-shuffles the rail
       under the user's finger. */
    if (!pinnedTog && (URL_CTOG || URL_CAT) && userTogChosen && activeCatTog) pinnedTog = activeCatTog;
    if (pinnedTog) {
      var pinAt = -1;
      catGroupsLive.forEach(function (b5, i5) { if (b5.label === pinnedTog) pinAt = i5; });
      if (pinAt > 0) catGroupsLive.unshift(catGroupsLive.splice(pinAt, 1)[0]);
    }
  }
  function renderCatToggles() {
    var el = document.getElementById('saw-cattog-' + SID);
    if (!el || !CAT_TOGGLES) return;
    el.innerHTML = catGroupsLive.map(function (b) {
      return '<button type="button" class="saw-ctog' + (b.label === activeCatTog ? ' is-active' : '') + '" data-ctog="' + b.label.replace(/"/g, '&quot;') + '">'
        + (b.img ? '<img class="saw-ctog-img" src="' + squareImg(b.img) + '" alt="" loading="lazy">' : '')
        + b.label + '</button>';
    }).join('')
    + (function () {
        if (!activeGroup) return '';
        var other = activeGroup === 'top' ? 'bottom' : 'top';
        var img = '';
        categories.forEach(function (c4) {
          if (!img && !c4.special && !c4.noTile && (other === 'top' ? c4.hasTop : c4.hasBottom) && c4.image) img = c4.image;
        });
        return '<button type="button" class="saw-ctog saw-ctog-switch" data-ctog-switch="' + other + '">'
          + (img ? '<img class="saw-ctog-img" src="' + squareImg(img) + '" alt="" loading="lazy">' : '')
          + (other === 'top' ? 'Topwear' : 'Bottomwear') + '</button>';
      })();
    /* keep the ACTIVE pill visible — a ?category deep link can select a group whose pill sits
       off-screen right; centre it in the rail (container-scoped, never scrolls the page) */
    var act = el.querySelector('.saw-ctog.is-active');
    if (act && el.scrollWidth > el.clientWidth) {
      el.scrollLeft = Math.max(0, act.offsetLeft - (el.clientWidth - act.offsetWidth) / 2);
    }
  }
  function syncUrlParams(kv) {   // keep the address bar honest as the user moves through the page
    if (!CAT_TOGGLES) return;
    try {
      var u = new URL(location.href);
      Object.keys(kv).forEach(function (k) { if (kv[k] == null) u.searchParams.delete(k); else u.searchParams.set(k, kv[k]); });
      history.replaceState(null, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  }
  function setCatTog(label, fromClick) {
    if (!CAT_TOGGLES || label === activeCatTog) return;
    activeCatTog = label; spyHold = false; userTogChosen = true;
    syncUrlParams({ ctoggle: label.toLowerCase().replace(/[^a-z0-9]+/g, '-'), category: null });
    renderCatToggles();
    applyGroupVisibility();
    if (fromClick) {
      var top = gridEl.getBoundingClientRect().top + window.pageYOffset - (getHeaderHeight() + stickyHeight()) - 4;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      setTimeout(syncSpy, 450);
    }
  }
  /* v3: mobile app nav — Menu → Discover (category browser), Returns → Filter (our overlay).
     Same capture-click pattern as new-collection-page. */
  /* mobile app nav: Returns → Filter (opens our sheet). Discover is gone in template 3. */
  function relabelAppNav() {
    if (LAYOUT === 'grid' || !id('saw-filter-overlay')) return;   /* grid has its own Filter button — the app nav keeps Returns */
    var ret = document.querySelector('#shopify-section-mobile-app-nav [data-nav="community"]');
    if (!ret) { setTimeout(relabelAppNav, 400); return; }
    var rLbl = ret.querySelector('.icon_name'); if (rLbl) rLbl.textContent = ' Filter ';
    var rImg = ret.querySelector('img');
    if (rImg) {
      var sp = document.createElement('span');
      sp.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2" stroke-linecap="round" style="width:21px;height:21px;display:block;margin:0 auto;"><line x1="4" y1="6" x2="20" y2="6"/><line x1="7" y1="12" x2="17" y2="12"/><line x1="10" y1="18" x2="14" y2="18"/></svg>';
      rImg.replaceWith(sp.firstChild);
    }
  }
  relabelAppNav();
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (LAYOUT === 'grid' || !id('saw-filter-overlay')) return;
    if (e.target.closest('#shopify-section-mobile-app-nav [data-nav="community"]')) { e.preventDefault(); e.stopPropagation(); openFilter(); }
  }, true);

  function renderFilterCatTogs() {
    var el = document.getElementById('saw-filter-cattog-' + SID);
    if (!el || !CAT_TOGGLES) return;
    el.innerHTML = catGroupsLive.map(function (b) {
      return '<button type="button" class="saw-fctog' + (b.label === tempCatTog ? ' on' : '') + '" data-fctog="' + b.label.replace(/"/g, '&quot;') + '">' + b.label + '</button>';
    }).join('');
  }
  var filterState = { size: [], colors: [], family: [], minPrice: 0, maxPrice: Infinity, bands: [] };
  var ffGender = '';   // '' | 'women' | 'men' — floating-bar gender filter (mixed-gender collections)
  function prodGender(p) {
    var t = p.tags || [];
    if (t.indexOf(WOMEN_TOP) !== -1 || t.indexOf(WOMEN_BOT) !== -1) return 'women';
    if (t.indexOf(MEN_TOP) !== -1 || t.indexOf(MEN_BOT) !== -1) return 'men';
    var ttl = (p.title || '').toLowerCase();
    return ttl.indexOf('women ') === 0 ? 'women' : ttl.indexOf('men ') === 0 ? 'men' : '';
  }
  var maxPriceLimit = 5000;
  var tempFilterSize = [];   /* sizes are multi-select: an array, not one value */
  /* 2026-09-18: "Find Your Size" exposes the size facet inline, next to Filter, in
     place of the item count. Opt-in per section so templates 3/4/5/6 keep the count. */
  var SIZEBAR = root.getAttribute('data-sizebar') === '1';
  var tempFilterColors = [];
  var tempFilterFamily = [];   // colour-family chip (single-select), products matched by their family tag
  var tfSel = { fit: [], fabric: [] }, tfTemp = { fit: [], fabric: [] };   // 2026-09-07: Fit / Fabric tag chips (applied / sheet draft)
  var FAMILY_GROUPS = [['Black','#20211c'],['White','#e1ded7'],['Neutral','#c5b79c'],['Grey','#776b5b'],['Blue','#353c46'],['Green','#666f51'],['Yellow','#e2c05f'],['Pink','#cd7780'],['Maroon','#a12a2c'],['Brown','#54483e'],['Purple','#ccb498']];
  var tempFilterGroup = LOCK_GROUP || null;
  var qaSelectedVariantId = null;
  var qaCurrentProduct = null;

  /* ───────── fetch whole collection (paginated) ───────── */
  function buildQuery(after, size) {
    var afterArg = after ? (', after: "' + after + '"') : '';
    var sortArg = SORT_BEST ? ', sortKey: BEST_SELLING' : '';
    return '{ collection(handle: "' + COLLECTION + '") { products(first: ' + (size || 100) + afterArg + sortArg + ') {'
      + ' pageInfo { hasNextPage endCursor }'
      + ' edges { node {'
      + ' id title handle onlineStoreUrl totalInventory tags productType createdAt'
      + ' catName: metafield(namespace: "custom", key: "' + CAT_KEY + '") { value }'
      + ' catImg: metafield(namespace: "custom", key: "' + IMG_KEY + '") { value reference { ... on MediaImage { image { url } } } }'
      + ' colorMeta: metafield(namespace: "custom", key: "product_variant_name") { value }'
      + ' ownRating: metafield(namespace: "custom", key: "review_rating") { value }'
      + ' ownCount: metafield(namespace: "custom", key: "review_count") { value }'
      + ' ratingMeta: metafield(namespace: "loox", key: "avg_rating") { value }'
      + ' ratersMeta: metafield(namespace: "loox", key: "num_reviews") { value }'
      + ' colorGroup: metafield(namespace: "custom", key: "' + COLOR_KEY + '") { value }'
      + ' images(first: 4) { edges { node { url(transform: {maxWidth: 440}) } } }'
      + ' plPrice: metafield(namespace: "custom", key: "prelaunch_price") { value } plCmp: metafield(namespace: "custom", key: "prelaunch_compare_at") { value }'
      + ' variants(first: 20) { edges { node { id price { amount } compareAtPrice { amount } availableForSale quantityAvailable selectedOptions { name value } } } }'
      + ' } } } } }';
  }

  function gql(query, signal) {
    return fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': TOKEN },
      body: JSON.stringify({ query: query }), signal: signal
    }).then(function (r) { if (!r.ok) throw new Error('Catalogue HTTP ' + r.status); return r.json(); });
  }

  function fetchAll() {
    var raw = [];
    function page(after) {
      return gql(buildQuery(after)).then(function (j) {
        var coll = j && j.data && j.data.collection;
        if (!coll) return raw;
        var conn = coll.products;
        (conn.edges || []).forEach(function (e) { raw.push(e.node); });
        if (conn.pageInfo && conn.pageInfo.hasNextPage && raw.length < MAX) {
          return page(conn.pageInfo.endCursor);
        }
        return raw;
      });
    }
    return page(null).catch(function (err) { console.error('SAW fetch error', err); return raw; });
  }

  function resolveCatImage(node) {
    if (node.catImg) {
      if (node.catImg.reference && node.catImg.reference.image && node.catImg.reference.image.url) return node.catImg.reference.image.url;
      var v = node.catImg.value || '';
      if (/^https?:\/\//.test(v)) return v;
    }
    return '';
  }

  /* CHANGE LOG BY DEVESH 2026-10-17: launch pins — style codes in window.__launchPins (theme.liquid head, from the shop
     launch list custom.launch_order_tags: start + label_days, default 7) lead their category and the page; expires by itself. */
  var LAUNCH = (window.__launchPins || []).map(function (c) { return String(c).toLowerCase(); });
  function normalize(p) {
    if ((p.tags || []).indexOf('ab-hide') !== -1) return null;   /* ab-hide: A/B copy, own PDP only */
    // No stock-based early return — every colour flows through so Step 1 can count all of a
    // category's size SKUs. Stock filtering happens later, in sequence (Step 1 -> Step 2).
    var edges = p.variantData ? p.variantData.map(function (v) {
      return { node: { selectedOptions: [{ name: 'Size', value: v[0] }], quantityAvailable: v[1],
        price: { amount: v[2] }, compareAtPrice: v[3] == null ? null : { amount: v[3] } } };
    }) : ((p.variants && p.variants.edges) || []);
    var v = (edges.find(function (e) { return e.node.quantityAvailable > 0; }) || {}).node || (edges[0] || {}).node;
    var basePrice = parseFloat((v && v.price && v.price.amount) || 0);
    var cmpRaw    = parseFloat((v && v.compareAtPrice && v.compareAtPrice.amount) || 0);
    /* Lister pre-launch display price — mirrors behtar-cotton-launch-js. Display only; checkout charges the real price. */
    var plv = p.plPrice ? parseFloat(p.plPrice.value) : 0;
    if (plv > 0) { basePrice = plv; var plc = p.plCmp ? parseFloat(p.plCmp.value) : 0; cmpRaw = plc > plv ? plc : 0; }
    var compare   = cmpRaw > basePrice ? cmpRaw : basePrice * COMPARE_MULT;

    var allImages = p.images.edges.map(function (e) { return e.node.url; });
    var colorVal  = (p.colorMeta && p.colorMeta.value) ? p.colorMeta.value.trim() : '';
    var swatchVal = (p.swatchMeta && p.swatchMeta.value) ? p.swatchMeta.value.trim().replace(/[;"']/g, '') : '';  // e.g. "rgb(102,111,81)" or "#3f5a2e"
    var rawColor  = colorVal || p.title;
    var tagsLower = (p.tags || []).map(function (t) { return t.toLowerCase().trim(); });

    var mapped = edges.map(function (e) {
      var sizeOpt = e.node.selectedOptions.find(function (o) { return o.name.toLowerCase() === 'size'; });
      return {
        id: String(e.node.id || '').split('/').pop(),   /* the catalogue snapshot omits variant ids */
        size: sizeOpt ? sizeOpt.value : 'Default',
        available: e.node.quantityAvailable > 0,
        qty: e.node.quantityAvailable || 0,
        price: parseFloat(e.node.price.amount)
      };
    });
    var sizes = [];
    var isNewCol = !!NEW_TAG && tagsLower.indexOf(NEW_TAG) !== -1;
    mapped.forEach(function (m) { if ((m.available || isNewCol) && m.size !== 'Default' && sizes.indexOf(m.size) === -1) sizes.push(m.size); });
    sizes.sort(function (a, b) { return (sizeOrderMap[a] || 99) - (sizeOrderMap[b] || 99); });
    // ── per-colour SKU stats — filtering happens later, in sequence (no early return here) ──
    var sizeVars  = mapped.filter(function (m) { return m.size !== 'Default'; });
    var countVars = sizeVars.length ? sizeVars : mapped;             // one-size products counted on their single variant
    var skuCount  = countVars.length;                                // total size SKUs for this colour
    var skuGt0    = countVars.filter(function (m) { return m.qty > 0; }).length;          // Step 1 metric: SKUs with stock (qty > 0)
    var sumQty    = countVars.reduce(function (a, m) { return a + (m.qty || 0); }, 0);
    var avgQty    = skuCount > 0 ? (sumQty / skuCount) : 0;          // Step 2 metric: average units across this colour's size SKUs

    var fromMeta  = (p.catName && p.catName.value) ? p.catName.value.trim() : '';
    var fromTitle = deriveCatLabel(p.title, colorVal);
    var catLabel  = (CAT_SOURCE === 'title' ? (fromTitle || fromMeta) : (fromMeta || fromTitle)) || (p.productType && p.productType.trim()) || 'Other';

    return {
      title: p.title, colorName: rawColor, swatch: swatchVal, handle: p.handle,
      link: p.onlineStoreUrl || ('/products/' + p.handle),
      image: allImages[0] || '', images: allImages,
      price: basePrice, compare: compare,
      tags: tagsLower, sizes: sizes, variants: mapped,
      kiwiId: (p.kiwiChart && p.kiwiChart.value) ? p.kiwiChart.value.trim() : '',
      specs: (p.specs && p.specs.reference) || null,
      /* the product's OWN numbers (scripts/loox_per_product.py + the nightly lister cron) come first;
         Loox groups reviews across a style, so its avg_rating repeats the family total on every colour */
      rating: (p.ownRating && p.ownRating.value) || (p.ratingMeta && p.ratingMeta.value) || '',
      raters: (p.ownCount && p.ownCount.value) || (p.ratersMeta && p.ratersMeta.value) || '',
      catLabel: catLabel, catImage: resolveCatImage(p),
      createdAt: Date.parse(p.createdAt || '') || 0,
      gid: p.id || '', siblingGids: parseGids(p.colorGroup && p.colorGroup.value), totalInv: p.totalInventory || 0,
      u30: (typeof p.u30 === 'number') ? (UNITS30[p.handle] = p.u30) : (UNITS30[p.handle] || 0),
      skuCount: skuCount, skuGt0: skuGt0, avgQty: avgQty,
      isTop: tagsLower.indexOf(TOP_TAG) !== -1,
      isBottom: tagsLower.indexOf(BOT_TAG) !== -1,
      displaySize: sizes.length > 1 ? (sizes[0] + ' - ' + sizes[sizes.length - 1]) : (sizes[0] || ''),
      isNewCol: isNewCol,
      isLaunch: LAUNCH.length > 0 && LAUNCH.some(function (c) { return tagsLower.indexOf(c) !== -1; })
    };
  }

  function normalizeList(nodes) {
    var out = [];
    nodes.forEach(function (n, i) { var p = normalize(n); if (p) {
      p.rank = i;
      for (var lc in LAUNCH_PRICES) { if ((p.tags || []).indexOf(lc) !== -1) { p.price = LAUNCH_PRICES[lc]; p.compare = LAUNCH_PRICES[lc] * COMPARE_MULT; break; } }
      out.push(p);
    } });
    return out;   // rank = position in the collection's BEST_SELLING order
  }
  /* ?category=<slug> makes that category's tile AND row lead the page — same contract as the
     All Linen pages, which use ?category=purelinen|flowylinen|airylinen. Matching is
     punctuation-insensitive, so ?category=short-kurta and ?category=shortkurta both work.
     Composes with ?gender= / ?tab= (gender picks the catalogue, category picks the order). */
  function normCat(v) { return String(v || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  /* ?category= accepts a comma list — each named category pins in the given order, rest keep
     the default sort. Single value behaves exactly as before. */
  var URL_CATS = (function () {
    try {
      return (new URLSearchParams(location.search).get('category') || '')
        .split(',').map(normCat).filter(Boolean);
    } catch (e) { return []; }
  })();
  var URL_CAT = URL_CATS[0] || '';
  function scoreOf(u, s, mu, ms) { return 0.7 * u / (mu || 1) + 0.3 * s / (ms || 1); }
  function sortByScore(list) {   // SCORE_SORT: colours inside one category
    var mu = 0, ms = 0;
    list.forEach(function (p) { mu = Math.max(mu, p.u30 || 0); ms = Math.max(ms, p.totalInv || 0); });
    return list.sort(function (a, b) {
      if (!!a.isLaunch !== !!b.isLaunch) return a.isLaunch ? -1 : 1;
      if (!!a.isNewCol !== !!b.isNewCol) return a.isNewCol ? -1 : 1;
      return scoreOf(b.u30 || 0, b.totalInv || 0, mu, ms) - scoreOf(a.u30 || 0, a.totalInv || 0, mu, ms);
    });
  }
  function sortCategories() {
    var order = (CAT_ORDER || '').split('\n').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
    function pinned(cat) { var i = order.indexOf((cat.label || '').toLowerCase()); return i === -1 ? 9999 : i; }
    function urlPin(cat) {
      if (!URL_CATS.length) return 9999;
      var i = URL_CATS.indexOf(normCat(cat.slug));
      if (i === -1) i = URL_CATS.indexOf(normCat(cat.label));
      return i === -1 ? 9999 : i;
    }
    // best seller of the category, counting ONLY colours that survived the stock gates
    function bestRank(cat) {
      var best = Infinity;
      (cat.products || []).forEach(function (p) { if (typeof p.rank === 'number' && p.rank < best) best = p.rank; });
      return best;
    }
    categories.forEach(function (cat) { cat.bestRank = bestRank(cat); cat.hasLaunch = (cat.products || []).some(function (p) { return p.isLaunch; }); });
    /* 2026-08-17: colour order INSIDE a category — colours with ALL sizes in stock lead (a best
       seller missing sizes must not front the carousel); inside each bucket best seller first,
       then deeper live inventory, then fullest size run. 60%-OOS gate unchanged. */
    categories.forEach(function (cat) {
      if (SCORE_SORT) { sortByScore(cat.products || []); return; }
      (cat.products || []).sort(function (a, b) {
        if (!!a.isLaunch !== !!b.isLaunch) return a.isLaunch ? -1 : 1;   // 0. launch styles lead (launch pins)
        if (!!a.isNewCol !== !!b.isNewCol) return a.isNewCol ? -1 : 1;   // 0. new colours lead (data-new-tag)
        var fa = ((a.skuCount || 0) > 0 && a.skuGt0 === a.skuCount) ? 0 : 1;
        var fb = ((b.skuCount || 0) > 0 && b.skuGt0 === b.skuCount) ? 0 : 1;
        if (fa !== fb) return fa - fb;                              // 1. full size run leads
        if ((a.rank || 0) !== (b.rank || 0)) return (a.rank || 0) - (b.rank || 0);   // 2. best seller
        if ((a.totalInv || 0) !== (b.totalInv || 0)) return (b.totalInv || 0) - (a.totalInv || 0);   // 3. deeper inventory
        var ra = (a.skuCount || 0) > 0 ? a.skuGt0 / a.skuCount : 0;
        var rb = (b.skuCount || 0) > 0 ? b.skuGt0 / b.skuCount : 0;
        return rb - ra;                                             // 4. fuller size run
      });
    });
    var catMU = 0, catMS = 0;
    if (SCORE_SORT) categories.forEach(function (cat) {
      var u = 0, st = 0; (cat.products || []).forEach(function (p) { u += p.u30 || 0; st += p.totalInv || 0; });
      cat._u30 = u; cat._stock = st; catMU = Math.max(catMU, u); catMS = Math.max(catMS, st);
    });
    categories.sort(function (a, b) {
      if ((a.special === 'fbt') !== (b.special === 'fbt')) return a.special === 'fbt' ? 1 : -1;   // FBT row always last
      var ua = urlPin(a), ub = urlPin(b);
      if (ua !== ub) return ua - ub;                            // 0. ?category= leads the page
      if (!!a.hasLaunch !== !!b.hasLaunch) return a.hasLaunch ? -1 : 1;   // 0b. launch styles lead the page (launch pins)
      var pa = pinned(a), pb = pinned(b);
      if (pa !== pb) return pa - pb;                            // 1. explicit Category order wins
      if (SCORE_SORT) return scoreOf(b._u30, b._stock, catMU, catMS) - scoreOf(a._u30, a._stock, catMU, catMS);   // 2'. units + stock score
      if (SORT_BEST && a.bestRank !== b.bestRank) return a.bestRank - b.bestRank;   // 2. best seller in stock
      var ia = 0, ib = 0;
      (a.products || []).forEach(function (p) { ia += p.totalInv || 0; });
      (b.products || []).forEach(function (p) { ib += p.totalInv || 0; });
      return ib - ia;                                           // 3. higher live inventory wins (was colour depth)
    });
  }
  function buildCategories(prods) {
    allProducts = {};
    var map = {};
    prods.forEach(function (p) {
      allProducts[p.handle] = p;
      var slug = slugify(p.catLabel);
      if (!map[slug]) map[slug] = { key: p.catLabel, label: p.catLabel, slug: slug, image: '', group: null, hasTop: false, hasBottom: false, topCount: 0, botCount: 0, products: [] };
      var cat = map[slug];
      cat.products.push(p);
      if (p.isTop) cat.topCount++;
      if (p.isBottom) cat.botCount++;
      if (!cat.metaImage) cat.metaImage = p.catImage || '';
    });
    categories = Object.keys(map).map(function (k) { return map[k]; })
      .filter(function (c0) { return !catHidden(c0.label); });
    categories.forEach(function (cat) {
      // group = majority of products' tags (robust to a single stray mistag)
      cat.group = (cat.topCount === 0 && cat.botCount === 0) ? null : (cat.botCount > cat.topCount ? 'bottom' : 'top');
      cat.hasTop = cat.group === 'top';
      cat.hasBottom = cat.group === 'bottom';
    });
    applyStep1Colours();   // Step 1 (colour gate): per-colour in-stock SKU rate
    applyStep2Colours();   // Step 2 (colour gate): per-colour average units
    sortCategories();
    foldSinglesIntoExploreMore();   // one-product categories collapse into a trailing catch-all row
    assignCatImages();     // tile images last — needs the final order to avoid repeating a colour
    assignCatTogGroups();  // 2026-08-17: category toggle groups (needs labels + tile images)
  }
  /* A category left with a single colour reads as a broken row (one lonely card under its own
     heading, and a roundel tile that leads nowhere). Fold every such category into one trailing
     "Explore More" row. It carries noTile, so the roundel rail skips it — it is a destination you
     scroll to, not a tab you jump to. Runs after sortCategories so it always lands last. */
  var EXPLORE_SLUG = 'explore-more';
  function foldSinglesIntoExploreMore() {
    var keep = [], singles = [];
    categories.forEach(function (cat) {
      if (cat.slug === EXPLORE_SLUG) return;                 // never fold the catch-all into itself
      (cat.products.length === 1 ? singles : keep).push(cat);
    });
    if (singles.length < 2) return;                          // one lonely row is not worth a catch-all
    var merged = { key: 'Explore More', label: 'Explore More', slug: EXPLORE_SLUG, image: '', metaImage: '',
                   group: null, hasTop: false, hasBottom: false, topCount: 0, botCount: 0,
                   products: [], noTile: true, bestRank: Infinity };
    singles.forEach(function (cat) {
      cat.products.forEach(function (p) { merged.products.push(p); });
      merged.topCount += cat.topCount; merged.botCount += cat.botCount;
      if (typeof cat.bestRank === 'number' && cat.bestRank < merged.bestRank) merged.bestRank = cat.bestRank;
    });
    // keep the group flags meaningful so the Topwear/Bottomwear filter still behaves
    merged.hasTop = merged.topCount > 0;
    merged.hasBottom = merged.botCount > 0;
    categories = keep.concat([merged]);
  }
  /* Tile images: a merchant-set category image always wins. Otherwise pick the first colour of the
     category that no earlier tile already used, so the row doesn't show three Rose Taupe tiles. */
  function assignCatImages() {
    var used = {};                                  // colour -> how many tiles already use it
    function colourKey(p) {
      var c = (p.colorName || '').toLowerCase().trim();
      // fold shade words together so "Jet Black" doesn't count as different from "Black"
      c = c.replace(/\b(jet|deep|dark|light|pale|bright|neon|classic|solid)\b/g, ' ').replace(/\s+/g, ' ').trim();
      return c;
    }
    categories.forEach(function (cat) {
      if (cat.metaImage) { cat.image = cat.metaImage; return; }
      var pick = null, pickKey = '', best = Infinity;
      for (var i = 0; i < cat.products.length; i++) {
        var k = colourKey(cat.products[i]);
        var n = k ? (used[k] || 0) : 0;
        if (n === 0) { pick = cat.products[i]; pickKey = k; break; }   // unused colour → take it
        if (n < best) { best = n; pick = cat.products[i]; pickKey = k; }   // else remember the least-used
      }
      if (!pick) return;
      cat.image = pick.image || '';
      if (pickKey) used[pickKey] = (used[pickKey] || 0) + 1;
    });
  }
  // ── Step 1 (colour gate): a colour (product) shows only if >= RATE of its OWN size SKUs
  //    have stock (qty > 0). Evaluated per product, not per category.
  function applyStep1Colours() {
    categories.forEach(function (cat) {
      cat.products = cat.products.filter(function (p) {
        if (p.isNewCol) return true;   // pre-launch colours show at 0 stock (owner, 2026-10-01)
        if (BROKEN_SIZES) return (p.skuCount || 0) >= 2 && p.skuGt0 >= 1 && (p.skuCount - p.skuGt0) / p.skuCount >= 0.5;
        if (HEALTHY_SIZES) return (p.skuCount || 0) > 0 && p.skuGt0 / p.skuCount > 0.5;
        return (p.skuCount || 0) > 0 && (p.skuGt0 / p.skuCount) > RATE;
      });
    });
  }
  // ── Step 2 (colour gate): within surviving categories, show a colour only if the AVERAGE
  //    units across all its size SKUs is greater than STEP2_AVG_MIN. Categories left empty are dropped.
  function applyStep2Colours() {
    categories.forEach(function (cat) {
      /* 2026-08-13: avg-qty colour gate removed — visibility is only the 60%-OOS rule above */
    });
    categories = categories.filter(function (cat) { return cat.products.length > 0; });
  }

  function cdnImg(url, w) {
    if (!url) return url;
    if (url.indexOf('cdn.shopify') === -1 && url.indexOf('/cdn/shop') === -1) return url;
    if (/[?&]width=/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + w);
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function squareImg(url) {
    if (!url || ROUNDEL_FIT !== 'cover') return url;
    var isShopifyCdn = url.indexOf('cdn.shopify') !== -1 || url.indexOf('/cdn/shop') !== -1;
    if (!isShopifyCdn) return url;
    // 3:4 to match the tile box, cropped from the top so the model's head survives.
    // (Was 220x220 crop=center — the CDN chopped the head off before CSS ever saw the image.)
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=360&height=480&crop=top';
  }
  function stripW(t) {   // v3: gender word off tiles + cards ("Women Cotton Pants" → "Cotton Pants")
    return CAT_TOGGLES ? String(t || '').replace(/\bwomen\s+/gi, '').replace(/\s{2,}/g, ' ').trim() : String(t || '');
  }
  /* View All → the family's deepest-stock product (the colour most likely to have every size) */
  function viewAllHref(cat, list) {
    var best = null;
    (list || cat.products || []).forEach(function (p) { if (!best || (p.totalInv || 0) > (best.totalInv || 0)) best = p; });
    return best ? (best.link || ('/products/' + best.handle)) : '';
  }
  function rowShellHtml(cat) {
    var va = (cat.special || cat.slug === EXPLORE_SLUG) ? '' : viewAllHref(cat);   // a catch-all row has nothing to 'view all'
    if (LAYOUT === 'grid') {
      return '<div id="saw-cat-' + cat.slug + '-' + SID + '" class="saw-cat" data-cat="' + cat.slug + '" data-section="' + SID + '" data-top="' + cat.hasTop + '" data-bottom="' + cat.hasBottom + '"><div class="saw-track"></div></div>';
    }
    return '<div id="saw-cat-' + cat.slug + '-' + SID + '" class="saw-cat" data-cat="' + cat.slug + '" data-section="' + SID + '" data-top="' + cat.hasTop + '" data-bottom="' + cat.hasBottom + '">'
      + '<div class="saw-cat-head"><h2 class="saw-cat-title">' + stripW(cat.label) + '</h2>' + (va ? '<a class="saw3-viewall saw3-viewall--m" href="' + va + '">View All</a>' : '') + '</div>'
      + '<button class="cl-nav cl-nav--left" type="button" aria-label="Scroll left" data-dir="-1"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 18l-6-6 6-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
      + '<button class="cl-nav cl-nav--right" type="button" aria-label="Scroll right" data-dir="1"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
      + '<div class="saw-track"></div>'
      + '<div class="cl-progress-container"><div class="cl-progress-bar"></div></div>'
      + (va ? '<a class="saw3-viewall saw3-viewall--d" href="' + va + '">View All</a>' : '') + '</div>';
  }

  /* Row breaks — one strip after every BREAK_EVERY category carousels, alternating ticker / stats */
  var BREAK_EVERY = parseInt(root.getAttribute('data-break-every'), 10) || 3;
  var MQ_TEXT = root.getAttribute('data-marquee') || '';
  var STATIC_STRIP = root.getAttribute('data-static-strip') || '';
  /* Short grids never reach the first break slot (index 5), so they showed no Money Back strip at
     all. Opt-in per section rather than on by default: the long templates already place theirs
     between rows, and a second one at the tail would stack against the next section. */
  var TAIL_STRIP = (root.getAttribute('data-tail-strip') || '').toLowerCase();
  /* A list is appended in order after the last tile: "1,stats" = 7-Day strip, then the 4.8 banner. */
  var TAIL_STRIPS = TAIL_STRIP.split(',').map(function (x) { return x.trim(); }).filter(Boolean);
  /* data-grid-mid-breaks="0": no strips between grid tiles, so every product in the active toggle
     sits above the strips (a short toggle like Kurtas otherwise split after tile 6). */
  var GRID_MID_BREAKS = root.getAttribute('data-grid-mid-breaks') !== '0';
  /* Explicit strip sequence, e.g. data-break-order="mbn,stats": the strip at break k is
     BREAK_ORDER[k] and each kind appears AT MOST ONCE on the page — once the sequence runs out
     that break renders nothing rather than looping. Empty keeps the historic
     mbn -> marquee -> stats rotation, which repeats the stats artwork every third break. */
  var BREAK_ORDER = (root.getAttribute('data-break-order') || '').split(',')
    .map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
  /* 2026-10-02: a strip listed twice in data-break-order may repeat (e.g. "mbn,stats,-,mbn"); "-" = empty slot */
  function brkCount(names) { return BREAK_ORDER.filter(function (x) { return names.indexOf(x) !== -1; }).length; }
  var MBN_REPEAT = brkCount(['mbn', 'money', 'static']) > 1, STATS_REPEAT = brkCount(['stats', 'rating']) > 1;
  /* Rating under the card instead of a pill on the media (data-rate-below="1"). */
  var RATE_BELOW = root.getAttribute('data-rate-below') === '1';
  function mqHtml() {
    if (!MQ_TEXT) return '';
    var segs = MQ_TEXT.split('·').map(function (t) { return t.trim(); }).filter(Boolean);
    if (!segs.length) segs = [MQ_TEXT];
    var base = segs.map(function (t) { return '<span class="saw-mq-seg">' + esc(t) + '</span>'; }).join('');
    var half = base + base + base;
    return '<div class="saw-mq"><div class="saw-mq-track">' + half + half + '</div></div>';
  }
  var mbnUsed = false;
  function staticStripHtml() {
    if (mbnUsed && !MBN_REPEAT) return '';   /* one money-back banner per page — later slots fall through to the other strips */
    mbnUsed = true;
    return '<div class="saw-static-strip saw3-mbn">'
      + '<p class="saw3-mbn-t">14-Day <b>Easy Exchanges</b></p>'
      + '</div>';
  }
  var statsUsed = false;
  function statsHtml() {
    if (BREAK_ORDER.length && statsUsed && !STATS_REPEAT) return '';   /* no-repeat is opt-in; the rotation pages still cycle back to it */
    statsUsed = true;
    return '<div class="saadaa-statsbn">'
      + '<img class="sbn-d" src="https://cdn.shopify.com/s/files/1/0450/3476/6485/files/8l.webp?v=1790831219&width=2000" alt="" loading="lazy">'
      + '<img class="sbn-m" src="https://cdn.shopify.com/s/files/1/0450/3476/6485/files/DATA_BANNER_MOBILE.webp?v=1789633299&width=1000" alt="" loading="lazy">'
      + '</div>';
  }
  function orderedStrip(k) {
    var name = BREAK_ORDER[k];
    if (name === 'mbn' || name === 'money' || name === 'static') return staticStripHtml();
    if (name === 'stats' || name === 'rating') return statsHtml();
    if (name === 'marquee' || name === 'mq') return mqHtml();
    return '';
  }
  function shellsWithBreaks() {
    mbnUsed = false; statsUsed = false;
    var out = [], breaks = 0;
    var n = categories.length;
    /* Break positions are decided UP FRONT so the static strip always lands BETWEEN two category
       rows — never trailing the last one, where it stacked against the stats artwork that the
       Top Rated block renders at its own top. A page with too few rows to reach rotation slot 3
       gets the static strip on its LAST break instead; a page with no natural break at all but
       2+ rows gets one forced at the midpoint. */
    var every = BREAK_EVERY;
    if (every > 0 && n >= 3 && Math.floor((n - 1) / every) < 2) {
      every = Math.max(1, Math.floor((n - 1) / 2));   // short page → tighten so BOTH strips fit
    }
    var breakAfter = {};                        // row index → true
    if (every > 0) {
      for (var i = 0; i < n - 1; i++) if ((i + 1) % every === 0) breakAfter[i] = true;
    }
    if (!Object.keys(breakAfter).length && n >= 2) breakAfter[0] = true;
    categories.forEach(function (cat, i) {
      out.push(rowShellHtml(cat));
      if (!breakAfter[i]) return;
      /* BANNER → marquee → stats. The Money Back banner leads so even a single-break page
         shows it, and the tail prune (Most Loved boundary) can never remove the only copy. */
      var html;
      if (BREAK_ORDER.length) {
        html = orderedStrip(breaks);
        if (!html) return;                      // sequence exhausted → this break shows nothing
      } else {
        var slot = breaks % 3;
        html = slot === 0 ? staticStripHtml() : (slot === 1 ? mqHtml() : statsHtml());
        if (!html) html = statsHtml();          // any strip blank → fall back to the stats artwork
      }
      out.push(html);
      breaks++;
    });
    return out.join('');
  }
  function renderShells() {
    document.documentElement.classList.remove('saw-deep');
    var shellKey = categories.map(function (c) { return c.slug + ':' + c.products.map(function (p) { return p.handle; }).join(','); }).join('|');
    if (gridEl._sawShellKey !== shellKey) {
      gridEl.innerHTML = shellsWithBreaks();
      gridEl._sawShellKey = shellKey;
    }
    categories.forEach(function (cat) {
      cat.roundelEl = null;
      cat.rowEl     = document.getElementById('saw-cat-' + cat.slug + '-' + SID);
      cat.trackEl   = qs('.saw-track', cat.rowEl);
    });
    renderCatToggles();
    renderTfRail();
  }

  function esc(t) { return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  var RATE_STAR = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.6l2.7 6.2 6.8.5-5.2 4.4 1.6 6.6L12 16.7 6.1 20.3l1.6-6.6L2.5 9.3l6.8-.5z"/></svg>';
  /* Rating under the card: five stars filled to the score, then the score and the review count —
     the face ncp3's template-4 uses. It carries the same data-saw3-reviews attributes as the media
     pill, so the reviews overlay opens from either. Safe inside the body anchor: the click handler
     matches [data-saw3-reviews] and preventDefaults BEFORE the `.p-card a` bail that lets links win. */
  function rateRow(p) {
    var av = parseFloat(p.rating) || 0;
    if (!RATE_BELOW || av <= 0) return '';
    var full = Math.round(av), stars = '';
    for (var si = 1; si <= 5; si++) stars += '<span class="p-star' + (si <= full ? ' on' : '') + '">' + RATE_STAR + '</span>';
    var n = parseInt(p.raters, 10) || 0;
    return '<span class="p-rate-row" role="button" tabindex="0" data-saw3-reviews="' + encodeURIComponent(p.handle)
      + '" data-pid="' + esc(String(p.gid || p.id || '').split('/').pop())
      + '" data-title="' + esc(p.title || stripW(p.catLabel || ''))
      + '" data-rating="' + av.toFixed(1) + '" data-count="' + n + '" aria-label="Read reviews">'
      + '<span class="p-stars" aria-hidden="true">' + stars + '</span>'
      + '<span class="p-rate-num">' + av.toFixed(1) + '</span>'
      + (n > 0 ? '<span class="p-rate-n">(' + n + ')</span>' : '')
      + '</span>';
  }
  function ratePill(p) {
    var av = parseFloat(p.rating) || 0;
    if (av <= 0 || RATE_BELOW) return '';   /* one rating control per card, never both */
    return '<button type="button" class="p-rate-pill" data-saw3-reviews="' + encodeURIComponent(p.handle) + '" data-pid="' + esc(String(p.gid || p.id || '').split('/').pop()) + '" data-title="' + esc(p.title || stripW(p.catLabel || '')) + '" data-rating="' + av.toFixed(1) + '" data-count="' + (parseInt(p.raters, 10) || 0) + '" aria-label="Read reviews">' + av.toFixed(1)
      + '<svg class="p-rate-star" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.6l2.7 6.2 6.8.5-5.2 4.4 1.6 6.6L12 16.7 6.1 20.3l1.6-6.6L2.5 9.3l6.8-.5z"/></svg></button>';
  }
  /* Colour count for "Available in N+ colours" — the colour-group metafield when present,
     otherwise the number of loaded colours sharing this style (title minus the colour word). */
  function styleKeyOf(p) {
    var t = (p.title || '');
    if (p.colorName) t = t.replace(p.colorName, '');
    return t.replace(/\s{2,}/g, ' ').trim().toLowerCase();
  }
  function colourCount(p) {
    var meta = (p.siblingGids || []).length;
    if (meta > 1) return meta;
    var k = styleKeyOf(p), n = 0;
    Object.keys(allProducts).forEach(function (h) { if (styleKeyOf(allProducts[h]) === k) n++; });
    return n;
  }
  /* ── card: ncp3 face — rating pill, 3:4 frames (1 in DOM, rest on first touch), colour + size on the
     media, progress bar, price row with the yellow angled % OFF badge. No title (the row heading names
     the family; the colour sits on the image). ── */
  function cardHtml(p) {
    var imgs = (p.images && p.images.length ? p.images : [p.image]).slice(0, 3);
    var rest = imgs.slice(1).map(function (u) { return cdnImg(u, 440); }).join('|');
    var szr = (p.displaySize || '').replace(' - ', ' – ');
    var off = (p.compare && p.compare > p.price) ? Math.round((p.compare - p.price) / p.compare * 100) : 0;
    return '<div class="p-card' + (p.isNewCol ? ' is-newcol' : '') + '" data-handle="' + encodeURIComponent(p.handle) + '">'
      + '<div class="p-img-box">' + (p.isNewCol ? '<span class="p-newcol">' + esc(NEW_BADGE) + '</span>' : '')
      +   '<div class="p-car"' + (rest ? ' data-lazyframes="' + esc(rest) + '"' : '') + '>'
      +     '<img src="' + cdnImg(imgs[0], 440) + '" width="440" height="587" loading="lazy" decoding="async" alt="' + esc(p.title) + '">'
      +   '</div>'
      +   ratePill(p)
      +   '<div class="p-meta"><span class="p-colour">' + esc(p.colorName || '') + '</span>' + (szr ? '<span class="p-sizes">' + esc(szr) + '</span>' : '') + '</div>'
      +   (imgs.length > 1 ? '<span class="p-bar" aria-hidden="true"><span style="width:' + Math.round(100 / imgs.length) + '%"></span></span>' : '')
      + '</div>'
      + '<div class="p-price-row"><span class="p-price">₹ ' + inr.format(p.price) + '</span>'
      + (p.compare && p.compare > p.price ? '<span class="p-compare">₹ ' + inr.format(p.compare) + '</span>' : '')
      + (off > 0 ? '<span class="p-off">' + off + '% OFF</span>' : '')
      + '</div>'
      + rateRow(p)
      + '</div>';
  }
  /* progress bar fills left → right with the frame scroll (ncp3 rule) */
  function updateCarBar(car) {
    var pc = car.closest('.p-card'); if (pc) pc.classList.toggle('is-slid', car.scrollLeft >= car.scrollWidth - car.clientWidth - 4);   /* the hint stays until the last colour is reached */
    var bar = car.parentNode && car.parentNode.querySelector('.p-bar > span'); if (!bar) return;
    var max = car.scrollWidth - car.clientWidth; if (max <= 0) return;
    var one = car.clientWidth / car.scrollWidth * 100;
    bar.style.width = (one + (100 - one) * (car.scrollLeft / max)) + '%';
  }

  function expandCar(car) {
    var rest = car.getAttribute('data-lazyframes');
    if (!rest) return;
    car.removeAttribute('data-lazyframes');
    var first = car.querySelector('img');
    var alt = first ? (first.getAttribute('alt') || '') : '';
    car.insertAdjacentHTML('beforeend', rest.split('|').filter(Boolean).map(function (u) {
      /* grid tiles store "href^src" so each colour frame links to its own product; rows store a bare src */
      var pair = u.split('^'), src = pair[pair.length - 1];
      var img = '<img src="' + src + '" loading="lazy" decoding="async" alt="' + esc(alt) + '">';
      return pair.length > 1 ? '<a class="p-frame" href="' + pair[0] + '">' + img + '</a>' : img;
    }).join(''));
  }
  /* Arrows are built on the card's first hover (after its deferred frames are in), so they cost nothing on
     phones and nothing at render time. Instant scroll: smooth fights the mandatory snap. */
  var saw3Arrow = function (d) { return '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="' + (d < 0 ? '15 5 8 12 15 19' : '9 5 16 12 9 19') + '"/></svg>'; };
  document.addEventListener('mouseover', function (e) {
    var card = e.target.closest && e.target.closest('.saw3 .p-card'); if (!card || card.querySelector('.p-nav')) return;
    var car = card.querySelector('.p-car'), box = card.querySelector('.p-img-box'); if (!car || !box) return;
    expandCar(car);
    var nav = document.createElement('span'); nav.className = 'p-nav';
    nav.innerHTML = '<button type="button" data-saw3-step="-1" aria-label="Previous image">' + saw3Arrow(-1) + '</button>'
      + '<button type="button" data-saw3-step="1" aria-label="Next image">' + saw3Arrow(1) + '</button>';
    box.appendChild(nav);
    if (car.scrollWidth > car.clientWidth + 2) nav.classList.add('is-on');
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-saw3-step]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var car = b.closest('.p-card').querySelector('.p-car'), w = car.clientWidth, d = Number(b.getAttribute('data-saw3-step'));
    var max = car.scrollWidth - w, next = car.scrollLeft + d * w;
    if (next < -1) next = max; else if (next > max + 1) next = 0;
    car.scrollTo({ left: next, behavior: 'auto' });
    if (car.parentNode) { var pc = car.closest('.p-card'); if (pc) pc.classList.toggle('is-slid', car.scrollLeft >= car.scrollWidth - car.clientWidth - 4); }
  }, true);

  function wireCardCarousels(scope) {
    qsa('.p-car', scope || root).forEach(function (car) {
      if (car._sawCarBound) return;
      car._sawCarBound = true;
      var expand = function () { expandCar(car); };
      car.addEventListener('touchstart', expand, { passive: true });
      car.addEventListener('mouseenter', expand);
      car.addEventListener('scroll', function () {
        expandCar(car);
        var pc = car.closest('.p-card'); if (pc) pc.classList.toggle('is-slid', car.scrollLeft >= car.scrollWidth - car.clientWidth - 4);   /* the hint stays until the last colour is reached */
        requestAnimationFrame(function () { updateCarBar(car); });
      }, { passive: true });
    });
  }

  function filteredProducts(cat) {
    return cat.products.filter(function (p) {
      if (filterState.size && filterState.size.length) {
        var anySize = false;
        for (var si = 0; si < filterState.size.length; si++) {
          if (p.sizes.indexOf(filterState.size[si]) !== -1) { anySize = true; break; }
        }
        if (!anySize) return false;
      }
      if (filterState.colors.length && filterState.colors.indexOf((p.colorName || '').toLowerCase().trim()) === -1) return false;
      if (filterState.family && filterState.family.length && !filterState.family.some(function (ff) { return (p.tags || []).indexOf(ff.toLowerCase()) !== -1; })) return false;
      for (var tk in tfSel) if (tfSel[tk].length && !tfSel[tk].some(function (tt) { return (p.tags || []).indexOf(tt) !== -1; })) return false;
      if (ffGender && prodGender(p) !== ffGender) return false;
      if (filterState.bands && filterState.bands.length) {
        /* multi-select price: the product matches if it falls in ANY ticked band */
        var inBand = false;
        for (var bi = 0; bi < filterState.bands.length; bi++) {
          var b = filterState.bands[bi];
          if (p.price >= b[0] && p.price <= b[1]) { inBand = true; break; }
        }
        if (!inBand) return false;
      } else if (p.price < filterState.minPrice || p.price > filterState.maxPrice) return false;
      return true;
    });
  }
  function renderRow(cat) {
    if (!cat.trackEl) return;
    var list = filteredProducts(cat);
    /* 2026-09-25: View All follows what the row shows (gender, size, filters) — it was fixed at build time from the
       whole category, so on a Women view it could open a Men product (Broken Sizes / Sizes In Stock). */
    var vaHref = list.length ? viewAllHref(cat, list) : '';
    if (ROW_LIMIT && LAYOUT !== 'grid' && !cat.special && cat.slug !== EXPLORE_SLUG) {
      list = SCORE_SORT ? sortByScore(list.slice()) : list.slice().sort(function (a, b) { return ((a.rank || 0) - (b.rank || 0)) || ((b.totalInv || 0) - (a.totalInv || 0)); });
      var nextP = list[ROW_LIMIT];
      vaHref = nextP ? (nextP.link || ('/products/' + nextP.handle)) : '';
      list = list.slice(0, ROW_LIMIT);
    }
    if (cat.rowEl) qsa('.saw3-viewall', cat.rowEl).forEach(function (a) { if (vaHref) a.setAttribute('href', vaHref); a.style.display = vaHref ? '' : 'none'; });
    var html = list.length ? (LAYOUT === 'grid' ? catCardHtml(cat, list) : list.map(cardHtml).join('')) : '<div class="saw-loading">No products match.</div>';
    if (cat.trackEl._sawHtml === html) return;
    cat.trackEl.innerHTML = html;
    cat.trackEl._sawHtml = html;
    wireCardCarousels(cat.trackEl);
    initRowNav(cat);
  }
  /* ── grid layout: one tile per family. The tile's frames are the family's colours (deepest-stock
     first), so scrolling the image reveals every colour the family comes in. ── */
  /* No two tiles lead with the same colour: tiles are filled in order and each takes its deepest-stock colour
     whose shade is not already leading an earlier tile (falling back to its own deepest stock if every
     colour is taken). Same rule the Discover panel uses for its category art. */
  var gridLead = {}, gridSeen = 0;
  function shadeKey(p) {
    return (p.colorName || '').toLowerCase().trim()
      .replace(/\b(jet|deep|dark|light|pale|bright|neon|classic|solid)\b/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function catCardHtml(cat, list) {
    var byStock = list.slice().sort(function (a, b) { return (b.totalInv || 0) - (a.totalInv || 0); });
    var main = null, fallback = byStock[0];
    for (var i = 0; i < byStock.length; i++) {
      var k = shadeKey(byStock[i]);
      if (!k || !gridLead[k]) { main = byStock[i]; break; }
      /* every colour taken: prefer the least-used shade, and among equals the one used longest ago */
      var f = gridLead[shadeKey(fallback)] || { n: 0, at: 0 }, c = gridLead[k];
      if (c.n < f.n || (c.n === f.n && c.at < f.at)) fallback = byStock[i];
    }
    if (!main) main = fallback;
    var mk = shadeKey(main);
    if (mk) gridLead[mk] = { n: (gridLead[mk] ? gridLead[mk].n : 0) + 1, at: gridSeen++ };
    var frames = [main].concat(list.filter(function (p) { return p !== main; })).slice(0, 16);
    var href = function (p) { return esc(p.link || ('/products/' + p.handle)); };
    var ls = lifestyleOf(list);   // lifestyle photo leads; every colour (main included) follows on swipe
    var rest = (ls ? frames : frames.slice(1)).map(function (p) { return href(p) + '^' + cdnImg(p.image, 440); }).join('|');
    var off = (main.compare && main.compare > main.price) ? Math.round((main.compare - main.price) / main.compare * 100) : 0;
    var others = list.length - 1;
    return '<div class="p-card" data-handle="' + encodeURIComponent(main.handle) + '">'
      + '<div class="p-img-box">'
      +   '<div class="p-car"' + (rest ? ' data-lazyframes="' + esc(rest) + '"' : '') + '>'
      +     '<a class="p-frame" href="' + href(main) + '"><img src="' + cdnImg(ls || main.image, 440) + '" width="440" height="587" loading="lazy" decoding="async" alt="' + esc(main.title) + '"></a>'
      +   '</div>'
      +   ratePill(main)
      +   '<span class="p-mprice"><b>\u20b9 ' + inr.format(main.price) + '</b>'
      +   (main.compare && main.compare > main.price ? '<s>\u20b9 ' + inr.format(main.compare) + '</s>' : '') + '</span>'
      +   (frames.length + (ls ? 1 : 0) > 1 ? '<span class="p-bar" aria-hidden="true"><span style="width:' + Math.round(100 / (frames.length + (ls ? 1 : 0))) + '%"></span></span>' : '')
      + '</div>'
      + '<a class="p-body" href="' + href(main) + '">'
      +   '<span class="p-ttl-row"><span class="p-ttl">' + esc(stripW(cat.label)) + '</span>'
      +   ((main.displaySize || '') ? '<span class="p-sizes">' + esc(main.displaySize.replace(' - ', ' \u2013 ')) + '</span>' : '') + '</span>'
      +   '<span class="p-price-row"><span class="p-price">\u20b9 ' + inr.format(main.price) + '</span>'
      +   (main.compare && main.compare > main.price ? '<span class="p-compare">\u20b9 ' + inr.format(main.compare) + '</span>' : '')
      +   (off > 0 ? '<span class="p-off">' + off + '% OFF</span>' : '') + '</span>'
      +   rateRow(main)
      +   '<span class="p-colour">' + (others > 0 ? 'Available in ' + others + '+ colours' : esc(main.colorName || '')) + '</span>'
      +   (others > 0 ? '<span class="p-slide">Slide right to view more colors \u2192</span>' : '')
      + '</a></div>';
  }
  /* Grid breaks: the row engine puts a strip after every Nth CATEGORY, but the active toggle hides most
     categories, so the surviving strips landed between nearly every visible tile and broke the 2-up grid into
     single cards. Hide the engine's strips and re-insert one after every 6th VISIBLE tile; desktop hides them. */
  /* Bento (phones only): tiles alternate tall / short in a checkerboard — tall, short / short, tall — and each
     column packs against the tile above it, so there is no dead space under a short tile. Column is pinned per
     index and the row span is measured from the card's own height (grid rows are 8px), which lets dense
     placement interlock the two columns. Desktop keeps the plain 4/5-up grid. */
  function bentoLayout() {
    if (!BENTO || !gridEl) return;
    var phone = window.matchMedia('(max-width: 768px)').matches;
    var tileWidth = phone ? Math.max(0, (gridEl.clientWidth - 1) / 2) : 0;
    var tiles = qsa('.saw-cat', gridEl).filter(function (e) { return !e.classList.contains('is-hidden') && e.querySelector('.p-card'); });
    tiles.forEach(function (el, i) {
      el.classList.toggle('is-short', phone && (i % 4 === 1 || i % 4 === 2));
      el.style.gridColumn = phone ? String((i % 2) + 1) : '';
      el.style.gridRowEnd = phone ? 'span ' + Math.max(2, Math.round(tileWidth * ((i % 4 === 1 || i % 4 === 2) ? 4 / 3 : 9 / 5)) + 1) : '';
    });
    // Media-only bento heights follow CSS aspect ratios. One width read, then all writes
    // before paint: no collapsed 1px rows or read/write loop for every card.
  }
  // Recompute before the resized layout paints; delayed spans overlap 1px mobile rows.
  window.addEventListener('resize', bentoLayout);

  function bentoBanner() {
    /* bento: a full-width row inside the grid breaks the interlock, so the banner sits under the grid */
    if (!gridEl || !gridEl.parentNode) return;
    var id = 'saw3-mbn-' + SID;
    if (document.getElementById(id)) return;
    var tmp = document.createElement('div'); tmp.innerHTML = staticStripHtml();
    var el = tmp.firstElementChild; if (!el) return;
    el.id = id;
    gridEl.parentNode.insertBefore(el, gridEl.nextSibling);
  }
  function gridBreaks() {
    mbnUsed = false; statsUsed = false;
    if (LAYOUT !== 'grid' || !gridEl) return;
    if (BENTO) { qsa('.saw-static-strip, .saw-mq, .saadaa-statsbn', gridEl).forEach(function (e) { e.classList.add('is-hidden'); }); bentoBanner(); return; }   /* a full-width strip would break the interlock */
    qsa('[data-saw3-brk]', gridEl).forEach(function (e) { e.parentNode.removeChild(e); });
    qsa('.saw-static-strip, .saw-mq, .saadaa-statsbn', gridEl).forEach(function (e) { e.classList.add('is-hidden'); });
    var tiles = qsa('.saw-cat', gridEl).filter(function (e) { return !e.classList.contains('is-hidden'); });
    var makers = [staticStripHtml, mqHtml, statsHtml], k = 0;
    for (var i = 5; GRID_MID_BREAKS && i < tiles.length - 1; i += 6) {
      var html = makers[k % 3]() || makers[(k + 1) % 3]() || makers[(k + 2) % 3](); k++;
      if (!html) continue;
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var el = tmp.firstElementChild; if (!el) continue;
      el.setAttribute('data-saw3-brk', '1');
      tiles[i].insertAdjacentElement('afterend', el);
    }
    /* Close the products block with the Money Back strip. staticStripHtml() returns '' once the
       loop above has already placed it, so a long grid keeps its single mid-grid banner and only
       a grid too short to earn one gets the tail copy. `tiles` predates the inserts, so its last
       entry is still the last product row. */
    if (TAIL_STRIPS.length && tiles.length) {
      var tailAfter = tiles[tiles.length - 1];
      TAIL_STRIPS.forEach(function (name) {
        var tailHtml = name === 'stats' ? statsHtml() : staticStripHtml();
        if (!tailHtml) return;
        var tailTmp = document.createElement('div'); tailTmp.innerHTML = tailHtml;
        var tailEl = tailTmp.firstElementChild;
        if (!tailEl) return;
        tailEl.setAttribute('data-saw3-brk', '1');
        tailAfter.insertAdjacentElement('afterend', tailEl);
        tailAfter = tailEl;
      });
    }
  }
  function renderVisibleRows() {
    gridLead = {}; gridSeen = 0;   /* lead colours are spread per render, not per session */
    var eagerCount = 0;
    categories.forEach(function (cat) {
      if (!cat.rowEl || cat.rowEl.classList.contains('is-hidden')) return;
      renderRow(cat);
      if (eagerCount < 2) {
        qsa('.p-card img', cat.trackEl).slice(0, 2 - eagerCount).forEach(function (im) { eagerCount++; im.removeAttribute('loading'); im.setAttribute('fetchpriority', 'high'); });
      }
    });
  }

  function initRowNav(cat) {
    var track = cat.trackEl, wrap = cat.rowEl;
    var bar = qs('.cl-progress-bar', wrap), leftBtn = qs('.cl-nav--left', wrap), rightBtn = qs('.cl-nav--right', wrap);
    if (!track) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (bar) {
        if (bar.parentElement) bar.parentElement.style.display = max <= 2 ? 'none' : '';   // 2026-08-17: nothing to scroll -> no progress bar
        bar.style.width = max <= 0 ? '12%' : Math.min(100, Math.max(12, (track.scrollLeft / max) * 100)) + '%';
      }
      if (leftBtn && rightBtn) {
        if (max <= 2) { leftBtn.classList.remove('is-visible'); rightBtn.classList.remove('is-visible'); return; }
        leftBtn.classList.toggle('is-visible', track.scrollLeft > 2);
        rightBtn.classList.toggle('is-visible', track.scrollLeft < max - 2);
      }
    }
    function step(dir) { track.scrollBy({ left: dir * Math.round(track.clientWidth * 0.85), behavior: 'smooth' }); }
    if (!track._sawBound) {
      track._sawBound = true;
      track.addEventListener('scroll', update, { passive: true });
      track._sawUpdate = update;
      if (leftBtn)  leftBtn.addEventListener('click', function () { step(-1); });
      if (rightBtn) rightBtn.addEventListener('click', function () { step(1); });
    }
    setTimeout(update, 60);
  }
  window.addEventListener('resize', function () {
    categories.forEach(function (cat) { if (cat.trackEl && cat.trackEl._sawUpdate) cat.trackEl._sawUpdate(); });
  });

  /* ───────── group toggle (tag-based) ───────── */
  /* 2026-08-14: a break strip (banner/marquee/stats) must sit BETWEEN visible category rows —
     when group/gender/filter hides the rows after it, the break trailed into the next section
     (Money Back banner bleeding into Most Loved). Keep a break only with a visible row on BOTH sides. */
  /* Sequenced pages (data-break-order) place their strips against the rows that are actually on
     SCREEN. pruneBreaks can only unhide breaks that shellsWithBreaks already scattered through the
     full category list, and a category toggle leaves those stranded among the hidden rows — with
     Bottoms active, nine visible carousels kept exactly one strip and the 4.8 banner never
     appeared at all. Walk the visible rows instead and insert after every BREAK_EVERY of them. */
  function sequencedBreaks(parent, specials) {
    mbnUsed = false; statsUsed = false;
    qsa('[data-saw3-brk]', parent).forEach(function (e) { e.parentNode.removeChild(e); });
    qsa('.saw-static-strip, .saw-mq, .saadaa-statsbn', parent).forEach(function (e) { e.classList.add('is-hidden'); });
    var rows = Array.prototype.slice.call(parent.children).filter(function (el) {
      return el.classList && el.classList.contains('saw-cat')
        && !el.classList.contains('is-hidden') && specials.indexOf(el) === -1;
    });
    var every = BREAK_EVERY > 0 ? BREAK_EVERY : 3, placed = 0;
    /* `rows.length - 1` keeps every strip BETWEEN two carousels — a trailing one would stack
       against the artwork the next section renders at its own top. */
    for (var i = every - 1, k = 0; i < rows.length - 1 && k < BREAK_ORDER.length; i += every) {
      var html = orderedStrip(k); k++;
      if (!html) continue;
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var el = tmp.firstElementChild; if (!el) continue;
      el.setAttribute('data-saw3-brk', '1');
      rows[i].insertAdjacentElement('afterend', el); placed++;
    }
    /* 2026-10-01: rails too short for a between-rows strip (one-family MEN view) close with data-tail-strip */
    if (!placed && TAIL_STRIPS.length && rows.length) {
      var after = rows[rows.length - 1];
      TAIL_STRIPS.forEach(function (name) {
        var th = name === 'stats' ? statsHtml() : (name === 'mq' ? mqHtml() : staticStripHtml());
        if (!th) return;
        var tt = document.createElement('div'); tt.innerHTML = th;
        var te = tt.firstElementChild; if (!te) return;
        te.setAttribute('data-saw3-brk', '1');
        after.insertAdjacentElement('afterend', te); after = te;
      });
    }
  }
  function pruneBreaks() {
    var first = null;
    for (var ci = 0; ci < categories.length; ci++) { if (categories[ci].rowEl) { first = categories[ci].rowEl; break; } }
    if (!first || !first.parentNode) return;
    var kids = Array.prototype.slice.call(first.parentNode.children);
    function isBreak(el) { return /(^| )(saw-static-strip|saw-mq|saw-stats|saw-statsbn|saadaa-statsbn)( |$)/.test(el.className || ''); }
    var specials = [];   // Most Loved / Top Rated / Happening Now / Pair It With are sections, not category rows
    categories.forEach(function (c) { if (c.special && c.rowEl) specials.push(c.rowEl); });
    if (BREAK_ORDER.length) { sequencedBreaks(first.parentNode, specials); return; }
    function isVisZone(el) { return el.classList && el.classList.contains('saw-cat') && !el.classList.contains('is-hidden') && specials.indexOf(el) === -1; }
    var seenZone = false, pending = null, kept = [];
    kids.forEach(function (el) {
      if (isBreak(el)) {
        el.classList.add('is-hidden');
        if (seenZone && !pending) pending = el;
        return;
      }
      if (isVisZone(el)) {
        if (pending) { pending.classList.remove('is-hidden'); kept.push(pending); pending = null; }
        seenZone = true;
      }
    });
    /* 2026-08-15: strict rotation on the VISIBLE breaks — banner → marquee → stats, repeating —
       so pins/hidden rows can never stack two of the same strip together. */
    var makers = [staticStripHtml, mqHtml, statsHtml];
    kept.forEach(function (el, ki) {
      var html = makers[ki % 3]() || makers[(ki + 2) % 3]() || makers[(ki + 1) % 3]();
      if (!html) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var neo = tmp.firstElementChild;
      if (neo && !new RegExp('(^| )' + (neo.className || '').split(' ')[0] + '( |$)').test(el.className || '')) {
        el.parentNode.replaceChild(neo, el);
      }
    });
  }
  function applyGroupVisibility() {
    if (FFBAR) ffSync();
    categories.forEach(function (cat) {
      if (!cat.rowEl) return;                       // Explore More has no roundel — row only
      var groupOk = cat.special === 'fbt' || !activeGroup || (activeGroup === 'top' ? cat.hasTop : cat.hasBottom);
      if (CAT_TOGGLES && activeCatTog && !cat.special && !cat.noTile && cat.tGroup !== activeCatTog) groupOk = false;
      var visible = groupOk && filteredProducts(cat).length > 0;   // hide category + roundel when no products match the filter
      cat.rowEl.classList.toggle('is-hidden', !visible);
      if (cat.roundelEl) cat.roundelEl.classList.toggle('is-hidden', !visible);
    });
    renderVisibleRows();
    renderTfRail();
    var firstVisible = categories.find(function (c) { return c.rowEl && !c.rowEl.classList.contains('is-hidden'); });
    if (firstVisible && !spyHold && !urlCatPending()) setActiveRoundel(firstVisible.slug);   // spyHold: OOS deep link — no tile until the user scrolls
    else if (spyHold || urlCatPending()) qsa('.saw-roundel.is-active', root).forEach(function (r) { r.classList.remove('is-active'); });
    var emptyEl = document.getElementById('saw-empty-' + SID);
    if (emptyEl) emptyEl.style.display = firstVisible ? 'none' : 'block';
    if (LAYOUT === 'grid') { gridBreaks(); bentoLayout(); } else pruneBreaks();   // breaks live only between visible rows
    setupSpy();
  }
  function setActiveToggle() {
    if (LOCK_GROUP) { qsa('.saw-toggle-btn[data-group]', root).forEach(function (b) { b.style.display = 'none'; }); }
    qsa('.saw-toggle-btn[data-group]', root).forEach(function (b) {
      var g = b.getAttribute('data-group');
      b.classList.toggle('is-active', (activeGroup === null && g === 'all') || g === activeGroup);
    });
  }
  function bindToggle() {
    qsa('.saw-toggle-btn[data-group]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var g = btn.getAttribute('data-group');
        // tapping the already-active tab clears it, so All is reachable without an extra pill
        activeGroup = (g === 'all' || g === activeGroup) ? null : g;
        setActiveToggle();
        applyGroupVisibility();
        var top = gridEl.getBoundingClientRect().top + window.pageYOffset - (getHeaderHeight() + stickyHeight()) - 4;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        setTimeout(syncSpy, 450);                              // re-sync active roundel after the smooth scroll settles
      });
    });
  }

  function getHeaderHeight() {
    var header = qs('header.site-header') || qs('.section-header') || qs('#shopify-section-header');
    var ann = qs('.announcement-bar');
    var h = header ? header.getBoundingClientRect().height : 0;
    if (ann) h += ann.getBoundingClientRect().height;
    return h > 0 ? h : 72;
  }
  function stickyHeight() { var b = document.getElementById('saw-sticky-' + SID); return b ? b.offsetHeight : 80; }
  function handleSticky() {
    var spacer = document.getElementById('saw-roundel-spacer-' + SID);
    var bar = document.getElementById('saw-sticky-' + SID);
    if (!spacer || !bar) return;
    var hh = getHeaderHeight();
    if (spacer.getBoundingClientRect().top <= hh) {
      if (!bar.classList.contains('is-locked')) {
        spacer.style.height = bar.offsetHeight + 'px';
        bar.classList.add('is-locked');
        root.style.setProperty('--saw-sticky-top-' + SID, hh + 'px');
        bar.style.top = hh + 'px';
      }
    } else if (bar.classList.contains('is-locked')) {
      bar.classList.remove('is-locked');
      spacer.style.height = 'auto';
    }
  }
  function setActiveRoundel() {}
  var manualLockUntil = 0;
  function urlCatPending() { return !!URL_CAT && !fetchComplete && !categories.some(function (c) { return normCat(c.slug) === URL_CAT || normCat(c.label) === URL_CAT; }); }
  function syncSpy() {}
  function setupSpy() {}

  var lockScrollY = 0, bodyLockCount = 0;
  function lockBody() {
    if (++bodyLockCount > 1) return;
    lockScrollY = window.pageYOffset;
    var bs = document.body.style;
    bs.position = 'fixed'; bs.top = -lockScrollY + 'px'; bs.left = '0'; bs.right = '0'; bs.width = '100%'; bs.overflow = 'hidden';
  }
  function anyOverlayOpenW() {
    return !!document.querySelector('.saw-overlay.is-visible, [id^="saw-inline-home-"].is-visible');
  }
  function unlockBody() {
    bodyLockCount = Math.max(0, bodyLockCount - 1);
    if (bodyLockCount > 0 && anyOverlayOpenW()) return;   // self-heal: leaked counts can't freeze the page
    bodyLockCount = 0;
    var bs = document.body.style;
    bs.position = ''; bs.top = ''; bs.left = ''; bs.right = ''; bs.width = ''; bs.overflow = '';
    window.scrollTo({ top: lockScrollY, left: 0, behavior: 'instant' });
  }
  /* ───────── filter modal ───────── */
  function visibleProductsForFilter() {
    var out = [];
    categories.forEach(function (cat) {
      if (tempFilterGroup && cat.group !== tempFilterGroup) return;   // respect the modal's category toggle while building lists
      cat.products.forEach(function (p) { out.push(p); });
    });
    return out;
  }
  function renderFilterGroup() {
    if (LOCK_GROUP) { var lw = id('saw-filter-groupwrap'); if (lw) lw.style.display = 'none'; return; }
    var cont = id('saw-filter-group'); if (!cont) return;
    // Hide the whole block (heading included) unless BOTH sides exist — a lone "All / Topwear"
    // filters nothing, and an empty labelled block is what the old display:none markup produced.
    var anyTop = false, anyBottom = false;
    categories.forEach(function (c) { if (c.hasTop) anyTop = true; if (c.hasBottom) anyBottom = true; });
    var wrap = id('saw-filter-groupwrap');
    if (wrap) wrap.style.display = (anyTop && anyBottom) ? '' : 'none';
    qsa('.saw-fgroup-btn', cont).forEach(function (b) {
      var g = b.getAttribute('data-fgroup');
      b.classList.toggle('is-selected', (tempFilterGroup === null && g === 'all') || g === tempFilterGroup);
    });
  }
  /* Sizes on offer, ordered XS..4XL.
     Reads the whole product pool, not visibleProductsForFilter() — that one is scoped
     by the sheet's group filter, which is why an earlier version rendered nothing.
     Reads the APPLIED state, not the sheet's temp state: these chips are live, there
     is no Apply button behind them. */
  function sizeBarChips() {
    var all = {};
    Object.keys(allProducts).forEach(function (h) {
      var p = allProducts[h];
      (p && p.sizes || []).forEach(function (sz) { if (sz && sz !== 'Default') all[sz] = true; });
    });
    var arr = Object.keys(all).sort(function (a, b) {
      var ra = sizeOrderMap[a] || 99, rb = sizeOrderMap[b] || 99;
      return ra !== rb ? ra - rb : a.localeCompare(b);
    });
    if (!arr.length) return '';
    /* resetState() sets filterState.size to null, not []. Every other reader guards
       with `filterState.size && ...`; calling .indexOf on it directly threw inside
       the snapshot render and took the whole product build down with it. */
    var sel = filterState.size || [];
    return '<span class="saw3-sizebar">' + arr.map(function (sz) {
      var on = sel.indexOf(sz) !== -1;
      return '<button type="button" class="saw3-size-chip' + (on ? ' on' : '') + '"'
        + ' aria-pressed="' + (on ? 'true' : 'false') + '"'
        + ' data-saw3-size="' + esc(sz) + '">' + esc(sz) + '</button>';
    }).join('') + '</span>';
  }

  /* Toggling a bar chip applies straight away and keeps the sheet's temp state in
     step, so opening the sheet afterwards shows the same sizes already ticked. */
  function toggleBarSize(size) {
    if (!filterState.size) filterState.size = [];
    var i = filterState.size.indexOf(size);
    if (i === -1) filterState.size.push(size); else filterState.size.splice(i, 1);
    tempFilterSize = filterState.size.slice();
    updateFilterLabel();
    applyGroupVisibility();
  }

  function renderFilterSizes() {
    var cont = id('saw-filter-sizes'); if (!cont) return;
    var all = {};
    visibleProductsForFilter().forEach(function (p) { p.sizes.forEach(function (s) { all[s] = true; }); });
    var arr = Object.keys(all).sort(function (a, b) { var ra = sizeOrderMap[a] || 99, rb = sizeOrderMap[b] || 99; return ra !== rb ? ra - rb : a.localeCompare(b); });
    cont.innerHTML = arr.map(function (s) { return '<div class="saw-size-circ ' + (tempFilterSize.indexOf(s) !== -1 ? 'is-selected' : '') + '" data-fsize="' + s + '">' + s + '</div>'; }).join('');
  }
  function renderFilterFamilies() {
    var cont = id('saw-filter-fams'); if (!cont) return;
    var have = {};
    visibleProductsForFilter().forEach(function (p) { (p.tags || []).forEach(function (t) { have[t] = 1; }); });
    var groups = FAMILY_GROUPS.filter(function (g) { return have[g[0].toLowerCase()]; });
    var wrap = cont.parentNode;
    if (wrap) wrap.style.display = groups.length ? '' : 'none';
    cont.innerHTML = groups.map(function (g) {
      return '<button type="button" class="saw-fam' + (tempFilterFamily.indexOf(g[0]) !== -1 ? ' on' : '') + '" data-fam="' + g[0] + '">'
        + '<span class="saw-fam-sw" style="background:' + g[1] + '"></span>' + g[0] + '</button>';
    }).join('');
  }
  var TF_PRE = { fit: 'fit - ', fabric: 'fabric - ' };
  function tfLabel(k, t) { return t.slice(TF_PRE[k].length).replace(/\s+fit$/, '').replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); }).replace(/^Saadaa/, 'SAADAA'); }
  function renderFilterTf() {
    Object.keys(TF_PRE).forEach(function (k) {
      var cont = id('saw-filter-' + k); if (!cont) return;
      var have = {};
      visibleProductsForFilter().forEach(function (p) { (p.tags || []).forEach(function (t) { if (t.indexOf(TF_PRE[k]) === 0) have[t] = 1; }); });
      var tags = Object.keys(have).sort();
      if (cont.parentNode) cont.parentNode.style.display = tags.length ? '' : 'none';
      cont.innerHTML = tags.map(function (t) {
        return '<button type="button" class="saw-fam' + (tfTemp[k].indexOf(t) !== -1 ? ' on' : '') + '" data-tf="' + k + '" data-tft="' + t + '">' + esc(tfLabel(k, t)) + '</button>';
      }).join('');
    });
  }
  function openFilter() {
    tempFilterSize = (filterState.size || []).slice();
    tempFilterColors = filterState.colors.slice(); tempFilterFamily = (filterState.family || []).slice(); for (var tk in tfSel) tfTemp[tk] = tfSel[tk].slice();
    tempFilterGroup = activeGroup;
    tempCatTog = activeCatTog;
    renderFilterCatTogs();
    renderFilterGroup();
    renderFilterSizes();
    renderFilterFamilies(); renderFilterTf();
    syncFsTabs();
    var ov = id('saw-filter-overlay'); if (ov) { ov.classList.add('is-visible'); lockBody(); }
  }
  function closeFilter() { var ov = id('saw-filter-overlay'); if (ov) { ov.classList.remove('is-visible'); unlockBody(); } }
  function applyFilter() {
    filterState.size = tempFilterSize.slice();
    filterState.colors = tempFilterColors.slice(); filterState.family = tempFilterFamily.slice(); for (var tk2 in tfTemp) tfSel[tk2] = tfTemp[tk2].slice();
    var minI = id('saw-price-min-input'), maxI = id('saw-price-max-input');
    filterState.minPrice = minI ? (parseInt(minI.value, 10) || 0) : 0;
    filterState.maxPrice = maxI ? (parseInt(maxI.value, 10) || maxPriceLimit) : maxPriceLimit;
    /* template 6 writes its ticked price bands here as "0-1000,1000-1500" */
    filterState.bands = (root.getAttribute('data-price-bands') || '').split(',').filter(Boolean).map(function (r) {
      var pr = r.split('-'); return [parseInt(pr[0], 10) || 0, parseInt(pr[1], 10) || Infinity];
    });
    activeGroup = LOCK_GROUP || tempFilterGroup;   // apply the modal's category toggle (lock wins)
    if (CAT_TOGGLES && tempCatTog && tempCatTog !== activeCatTog) { activeCatTog = tempCatTog; spyHold = false; userTogChosen = true; renderCatToggles(); }
    setActiveToggle();               // keep the bottom-bar toggle in sync
    updateFilterLabel();
    applyGroupVisibility();   // re-evaluate visibility so empty categories + roundels hide
    closeFilter();
  }
  function clearFilter() {
    tempFilterSize = [];
    tempFilterColors = []; tempFilterFamily = []; tfTemp = { fit: [], fabric: [] }; tfSel = { fit: [], fabric: [] };
    tempFilterGroup = LOCK_GROUP || null;
    activeGroup = LOCK_GROUP || null;
    setActiveToggle();
    renderFilterGroup();
    filterState.size = [];
    filterState.colors = []; filterState.family = [];
    filterState.minPrice = 0;
    filterState.maxPrice = maxPriceLimit;
    filterState.bands = [];
    if (root.removeAttribute) root.removeAttribute('data-price-bands');
    var minR = id('saw-price-min-range'), maxR = id('saw-price-max-range'), minI = id('saw-price-min-input'), maxI = id('saw-price-max-input');
    if (minR) minR.value = 0;
    if (maxR) maxR.value = maxPriceLimit;
    if (minI) minI.value = 0;
    if (maxI) maxI.value = maxPriceLimit;
    if (window['_sawUpdateTrack_' + SID]) window['_sawUpdateTrack_' + SID]();
    renderFilterSizes();
    renderFilterFamilies(); renderFilterTf();
    updateFilterLabel();
    applyGroupVisibility();
  }
  /* ── Fit / Fabric chip rail under the toggles (Frido-style). Chips come from the tags of the products
     in the active toggle group; tapping one applies it straight away (no sheet). The Filter button opens
     the full sheet (size / colour / fit / fabric / price). ── */
  /* two-pane sheet: a section is empty when its render fn hid the container or left it without rows */
  function syncFsTabs(prefer) {
    var ov = id('saw-filter-overlay'); if (!ov) return;
    var tabs = qsa('.saw3-fs-tab', ov), panes = qsa('.saw3-fs-pane', ov), firstOn = null;
    var counts = { cat: 0, colour: tempFilterFamily.length, size: tempFilterSize.length, fit: tfTemp.fit.length, fabric: tfTemp.fabric.length, price: 0 };
    var cur = null;
    tabs.forEach(function (tab) {
      if (tab.classList.contains('on')) cur = tab.getAttribute('data-saw3-fs-tab');
      if (LAYOUT === 'grid' && /^(size|colour)$/.test(tab.getAttribute('data-saw3-fs-tab'))) { tab.hidden = true; return; }   /* tiles are families: no size, no colour */
      var key = tab.getAttribute('data-saw3-fs-tab'), pane = ov.querySelector('[data-saw3-fs-pane="' + key + '"]');
      var cont = pane && pane.firstElementChild, empty = !cont || cont.style.display === 'none' || (key !== 'price' && !cont.children.length);
      tab.hidden = empty;
      if (!tab.getAttribute('data-lbl')) tab.setAttribute('data-lbl', tab.textContent.trim());
      tab.innerHTML = esc(tab.getAttribute('data-lbl')) + (counts[key] ? '<span class="saw3-fs-n">' + counts[key] + '</span>' : '');
      if (!empty && !firstOn) firstOn = key;
    });
    var want = prefer || cur;
    if (!want || tabs.some(function (t) { return t.getAttribute('data-saw3-fs-tab') === want && t.hidden; })) want = firstOn;
    tabs.forEach(function (t) { t.classList.toggle('on', t.getAttribute('data-saw3-fs-tab') === want); });
    panes.forEach(function (p) { p.classList.toggle('on', p.getAttribute('data-saw3-fs-pane') === want); });
  }
  function railProducts() {
    var out = [];
    categories.forEach(function (cat) {
      if (cat.special) return;
      if (CAT_TOGGLES && activeCatTog && cat.tGroup !== activeCatTog) return;
      cat.products.forEach(function (p) { out.push(p); });
    });
    return out;
  }
  function renderTfRail() {
    var have = { fit: {}, fabric: {} };
    railProducts().forEach(function (p) { (p.tags || []).forEach(function (t) { Object.keys(TF_PRE).forEach(function (k) { if (t.indexOf(TF_PRE[k]) === 0) have[k][t] = 1; }); }); });
    var n = 0; for (var tk in tfSel) n += tfSel[tk].length;
    if (filterState.size && filterState.size.length) n++; if (filterState.family && filterState.family.length) n++;
    if (filterState.minPrice > 0 || filterState.maxPrice < maxPriceLimit) n++;
    var filterBtn = '<button type="button" class="saw3-chip saw3-chip-filter' + (n ? ' has' : '') + '" data-saw-open-filter>'
      + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="4" y1="6" x2="20" y2="6"/><line x1="7" y1="12" x2="17" y2="12"/><line x1="10" y1="18" x2="14" y2="18"/></svg>Filter' + (n ? ' <b>(' + n + ')</b>' : '') + '</button>';
    function chips(k) {
      return Object.keys(have[k]).sort().map(function (t) {
        return '<button type="button" class="saw3-chip' + (tfSel[k].indexOf(t) !== -1 ? ' on' : '') + '" data-saw3-tf="' + k + '" data-saw3-tft="' + esc(t) + '"><span class="saw3-tick"></span>' + esc(tfLabel(k, t)) + '</button>';
      }).join('');
    }
    var r1 = id('saw3-rail'), r2 = id('saw3-rail2');
    if (LAYOUT === 'grid') {
      /* tiles variant: the sheet only, plus the visible-family count on the right (the ncp3 toolbar's "N items") */
      if (r1) {
        var bar = SIZEBAR ? sizeBarChips() : '';
        if (bar) {
          r1.innerHTML = filterBtn + bar;
        } else {
          /* No sizes resolved yet (first paint, before the fetch lands) — keep the
             count rather than leaving the toolbar with a lone Filter chip. */
          var shown = gridEl ? qsa('.saw-cat', gridEl).filter(function (e) { return !e.classList.contains('is-hidden') && e.querySelector('.p-card'); }).length : 0;
          r1.innerHTML = filterBtn + '<span class="saw3-count">Showing <b>' + shown + '</b> item' + (shown === 1 ? '' : 's') + '</span>';
        }
      }
      return;
    }
    if (r1) r1.innerHTML = filterBtn + chips('fit');
    if (r2) { var fab = chips('fabric'); r2.innerHTML = fab ? '<span class="saw3-rail-lbl">Fabric</span>' + fab : ''; r2.hidden = !fab; }
  }
  function toggleRailTf(k, t) {
    var i = tfSel[k].indexOf(t);
    if (i === -1) tfSel[k].push(t); else tfSel[k].splice(i, 1);
    tfTemp[k] = tfSel[k].slice();
    updateFilterLabel();
    applyGroupVisibility();
  }

  function updateFilterLabel() {
    var labelEl = qs('[data-saw-filter-label]', root);
    if (!labelEl) return;
    var parts = [];
    if (filterState.size && filterState.size.length) parts.push(filterState.size.join(', '));
    if (ffGender) parts.push(ffGender === 'men' ? 'Men' : 'Women');
    for (var tk4 in tfSel) tfSel[tk4].forEach(function (t) { parts.push(tfLabel(tk4, t)); });
    if (filterState.minPrice > 0 || filterState.maxPrice < maxPriceLimit) parts.push('₹' + filterState.minPrice + '-' + filterState.maxPrice);
    labelEl.innerText = parts.length ? ' : ' + parts.join(', ') : '';
  }
  function setupSlider() {
    var minR = id('saw-price-min-range'), maxR = id('saw-price-max-range'), minI = id('saw-price-min-input'), maxI = id('saw-price-max-input'), track = id('saw-price-track');
    function updateTrack() {
      if (!minR || !maxR || !track) return;
      var lo = parseInt(minR.value, 10), hi = parseInt(maxR.value, 10), lim = parseInt(maxR.max, 10) || 1;
      if (lo > hi - 10) { lo = hi - 10; minR.value = lo; }
      track.style.left = (lo / lim * 100) + '%';
      track.style.width = ((hi - lo) / lim * 100) + '%';
      if (minI) minI.value = lo; if (maxI) maxI.value = hi;
    }
    function fromInputs() {
      if (!minI || !maxI || !maxR) return;
      var lo = parseInt(minI.value, 10) || 0, hi = parseInt(maxI.value, 10) || parseInt(maxR.max, 10), lim = parseInt(maxR.max, 10);
      if (lo < 0) lo = 0; if (hi > lim) hi = lim; if (lo > hi - 10) lo = hi - 10;
      if (minR) minR.value = lo; if (maxR) maxR.value = hi; updateTrack();
    }
    if (minR && maxR && minI && maxI) {
      minR.addEventListener('input', updateTrack); maxR.addEventListener('input', updateTrack);
      minI.addEventListener('change', fromInputs); maxI.addEventListener('change', fromInputs);
    }
    window['_sawUpdateTrack_' + SID] = updateTrack;
  }

  function openCard(handle) {
    var p = allProducts[handle];
    window.location.href = (p && p.link) || ('/products/' + handle);
  }
  var saw3RvCache = {};
  function saw3RvFetch(store, pid, page) {
    var key = pid + ':' + page;
    if (saw3RvCache[key]) return saw3RvCache[key];
    var url = 'https://storefront-api.loox.io/storefront/v1/store/' + store + '/product-reviews?product_id=' + pid + '&page=' + page + '&limit=' + (page === 1 ? 6 : 10);
    saw3RvCache[key] = fetch(url).then(function (r) { return r.ok ? r.json() : null; });
    return saw3RvCache[key];
  }
  function saw3RvThumb(url, w) {
    /* Loox offers no resize parameters, but its image host runs behind Cloudflare's resizer */
    return 'https://images.loox.io/cdn-cgi/image/width=' + w + ',quality=72,format=auto' + String(url).replace(/^https?:\/\/images\.loox\.io/, '');
  }
  function saw3RvStars(n) {
    var out = '';
    for (var i = 1; i <= 5; i++) out += '<svg class="' + (i <= n ? 'on' : '') + '" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.6l2.7 6.2 6.8.5-5.2 4.4 1.6 6.6L12 16.7 6.1 20.3l1.6-6.6L2.5 9.3l6.8-.5z"/></svg>';
    return '<span class="saw3-rv-stars">' + out + '</span>';
  }
  function saw3RvLoad(store, pid, list, page) {
    var box = root.querySelector('[data-saw3-rv]');
    var old = list.querySelector('[data-saw3-rv-more]'); if (old) old.parentNode.removeChild(old);
    saw3RvFetch(store, pid, page).then(function (d) {
      if (!box || box.hidden) return;
      var rows = (d && d.reviews) || [];
      if (!rows.length && page === 1) { list.innerHTML = '<p class="saw3-rv-empty">No reviews for this colour yet.</p>'; box.classList.add('is-ready'); return; }
      if (page === 1) {
        var total = (d.pagination || {}).total || rows.length;
        list.innerHTML = '<div class="saw3-rv-bar">' + saw3RvStars(5) + '<span class="saw3-rv-total">' + total.toLocaleString('en-IN') + ' Reviews</span></div><div class="saw3-rv-grid" data-saw3-rv-grid="1"></div>';
      }
      var grid = list.querySelector('[data-saw3-rv-grid]') || list;
      var narrow = window.matchMedia('(max-width: 768px)').matches;
      rows.forEach(function (rv) {
        var m = (rv.media || []).filter(function (x) { return x.url; })[0];
        var el = document.createElement('article');
        el.className = 'saw3-rv-item';
        el.innerHTML = (m ? '<div class="saw3-rv-media"><img src="' + esc(saw3RvThumb(m.url, narrow ? 360 : 480)) + '" alt="" decoding="async" onload="this.classList.add(\'is-on\')"></div>' : '')
          + '<div class="saw3-rv-txt"><span class="saw3-rv-who">' + esc((rv.reviewer && rv.reviewer.name) || 'Verified buyer') + '</span>'
          + saw3RvStars(rv.rating || 0)
          + (rv.body ? '<p class="saw3-rv-body">' + esc(rv.body) + '</p>' : '') + '</div>';
        grid.appendChild(el);
      });
      if ((d.pagination || {}).hasMore) {
        var btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'saw3-rv-more'; btn.setAttribute('data-saw3-rv-more', '1');
        btn.textContent = 'Show more reviews';
        btn.addEventListener('click', function () { btn.disabled = true; saw3RvLoad(store, pid, list, page + 1); });
        list.appendChild(btn);
      }
      box.classList.add('is-ready');
    }).catch(function () { if (page === 1) { list.innerHTML = '<p class="saw3-rv-empty">Could not load reviews.</p>'; box.classList.add('is-ready'); } });
  }
  /* hover / first touch warms the request so the panel opens on content */
  ['pointerenter', 'touchstart'].forEach(function (ev) {
    root.addEventListener(ev, function (e) {
      var pill = e.target.closest && e.target.closest('[data-saw3-reviews][data-pid]');
      if (!pill) return;
      var store = root.getAttribute('data-loox-store');
      if (store) saw3RvFetch(store, String(pill.getAttribute('data-pid')).replace(/\D/g, ''), 1).catch(function () {});
    }, { capture: true, passive: true });
  });

  /* reviews popup — port of template 3's: the storefront refuses to be framed (frame-ancestors 'none'), so the
     bare /products/<handle>?view=reviews-popup page is fetched same-origin and handed to the iframe as srcdoc */
  function saw3Reviews(pill) {
    var box = root.querySelector('[data-saw3-rv]'), scrim = root.querySelector('[data-saw3-rv-scrim]'), frame = root.querySelector('[data-saw3-rv-frame]');
    if (!box || !frame) return;
    box.classList.remove('is-ready');
    var ttl = root.querySelector('[data-saw3-rv-title]'); if (ttl) ttl.textContent = pill.getAttribute('data-title') || '';
    var sub = root.querySelector('[data-saw3-rv-sub]'), rating = pill.getAttribute('data-rating'), count = Number(pill.getAttribute('data-count') || 0);
    var star = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.6l2.7 6.2 6.8.5-5.2 4.4 1.6 6.6L12 16.7 6.1 20.3l1.6-6.6L2.5 9.3l6.8-.5z"/></svg>';
    if (sub) { sub.innerHTML = star + ' <b>' + esc(rating) + '</b>' + (count ? ' <span class="saw3-rv-dot">·</span> ' + count.toLocaleString('en-IN') + ' reviews' : ''); sub.hidden = false; }
    box.hidden = false; if (scrim) scrim.hidden = false; lockBody();
    var list = root.querySelector('[data-saw3-rv-list]'), store = root.getAttribute('data-loox-store'), pid = pill.getAttribute('data-pid');
    if (list && store && pid) {
      /* Loox groups reviews across a style, so its widget shows the family's list. The storefront API
         answers per product with no key — the same numbers the card is showing. */
      frame.hidden = true; list.hidden = false; list.innerHTML = '';
      saw3RvLoad(store, String(pid).replace(/\D/g, ''), list, 1);
      return;
    }
    frame.hidden = false; if (list) list.hidden = true;
    var url = '/products/' + pill.getAttribute('data-saw3-reviews') + '?view=reviews-popup';
    frame.onload = function () { box.classList.add('is-ready'); };
    fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      if (box.hidden) return;
      if (html.indexOf('loox-reviews-feed') === -1) { frame.srcdoc = '<p style="font:14px system-ui;padding:24px;text-align:center;color:#666">No reviews yet for this product.</p>'; box.classList.add('is-ready'); return; }
      frame.srcdoc = html.replace(/<head([^>]*)>/i, '<head$1><base href="' + location.origin + '/">');
    }).catch(function () { frame.srcdoc = '<p style="font:14px system-ui;padding:24px;text-align:center;color:#666">Could not load reviews.</p>'; box.classList.add('is-ready'); });
  }
  function saw3ReviewsClose() {
    var box = root.querySelector('[data-saw3-rv]'), scrim = root.querySelector('[data-saw3-rv-scrim]'), frame = root.querySelector('[data-saw3-rv-frame]');
    if (!box || box.hidden) return;
    box.hidden = true; if (scrim) scrim.hidden = true; if (frame) frame.removeAttribute('srcdoc'); unlockBody();
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') saw3ReviewsClose(); });
  root.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-saw3-reviews]');
    if (pill) { e.preventDefault(); e.stopPropagation(); saw3Reviews(pill); return; }
    if (e.target.closest('[data-saw3-rv-close]') || e.target.closest('[data-saw3-rv-scrim]')) { saw3ReviewsClose(); return; }
    if (e.target.closest('[data-saw3-rv]')) return;
    if (e.target.closest('[data-saw3-tf]') || e.target.closest('[data-saw-open-filter]')) return;
    if (e.target.closest('[data-saw3-step]')) return;   /* the frame arrows are not a product tap */
    if (e.target.closest('.p-card a')) return;   /* grid tiles link per colour — let the anchor win */
    var card = e.target.closest('.p-card');
    if (card && root.contains(card)) openCard(decodeURIComponent(card.getAttribute('data-handle')));
  });
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.id === 'saw-filter-overlay-' + SID) closeFilter();
    var rc = t.closest('.saw3-rails [data-saw3-tf]');
    if (rc) { toggleRailTf(rc.getAttribute('data-saw3-tf'), rc.getAttribute('data-saw3-tft')); return; }
    var own = function (el) { return el && root.contains(el); };
    if (own(t.closest('[data-saw-open-filter]'))) openFilter();
    if (t.closest('#saw-filter-overlay-' + SID + ' [data-saw-close-filter]')) closeFilter();
    if (t.closest('#saw-filter-overlay-' + SID + ' [data-saw-apply-filter]')) applyFilter();
    if (t.closest('#saw-filter-overlay-' + SID + ' [data-saw-clear-filter]')) clearFilter();
    var cTog = t.closest('#saw-cattog-' + SID + ' .saw-ctog');
    if (cTog && cTog.getAttribute('data-ctog')) { setCatTog(cTog.getAttribute('data-ctog'), true); return; }
    var cSw = t.closest('#saw-cattog-' + SID + ' [data-ctog-switch]');
    if (cSw) {
      activeGroup = cSw.getAttribute('data-ctog-switch');
      userTogChosen = false; activeCatTog = null; spyHold = false;
      syncUrlParams({ women_category: activeGroup === 'top' ? 'topwear' : 'bottomwear', ctoggle: null, category: null });
      assignCatTogGroups(); renderCatToggles(); applyGroupVisibility();
      return;
    }
    var fcTog = t.closest('#saw-filter-cattog-' + SID + ' .saw-fctog');
    if (fcTog) { tempCatTog = fcTog.getAttribute('data-fctog'); renderFilterCatTogs(); }
    var fGroup = t.closest('#saw-filter-group-' + SID + ' .saw-fgroup-btn');
    if (fGroup) { var g = fGroup.getAttribute('data-fgroup'); tempFilterGroup = (g === 'all') ? null : g; renderFilterGroup(); renderFilterSizes(); renderFilterFamilies(); renderFilterTf(); }
    var fsTab = t.closest('#saw-filter-overlay-' + SID + ' [data-saw3-fs-tab]');
    if (fsTab) { syncFsTabs(fsTab.getAttribute('data-saw3-fs-tab')); return; }
    if (t.closest('#saw-filter-overlay-' + SID + ' .saw3-fs-panes') || t.closest('#saw-filter-overlay-' + SID + ' [data-saw-clear-filter]')) setTimeout(function () { syncFsTabs(); }, 0);
    var barSize = t.closest('[data-saw3-size]');
    if (barSize && root.contains(barSize)) { toggleBarSize(barSize.getAttribute('data-saw3-size')); return; }
    var fSize = t.closest('#saw-filter-sizes-' + SID + ' .saw-size-circ');
    if (fSize) { var s = fSize.getAttribute('data-fsize'); var sIdx = tempFilterSize.indexOf(s); if (sIdx === -1) tempFilterSize.push(s); else tempFilterSize.splice(sIdx, 1); renderFilterSizes(); }
    var fFam = t.closest('#saw-filter-fams-' + SID + ' .saw-fam');
    if (fFam) { var fv = fFam.getAttribute('data-fam'); var fvi = tempFilterFamily.indexOf(fv); if (fvi === -1) tempFilterFamily.push(fv); else tempFilterFamily.splice(fvi, 1); renderFilterFamilies(); }
    var fTf = t.closest('#saw-filter-overlay-' + SID + ' [data-tf]');
    if (fTf) { var tk3 = fTf.getAttribute('data-tf'), tv = fTf.getAttribute('data-tft'), ti = tfTemp[tk3].indexOf(tv); if (ti === -1) tfTemp[tk3].push(tv); else tfTemp[tk3].splice(ti, 1); renderFilterTf(); }
  });
  window.addEventListener('scroll', handleSticky, { passive: true });
  window.addEventListener('resize', handleSticky);

  /* ───────── init ───────── */
  /* localStorage, not sessionStorage: a shopper coming back tomorrow paints from cache instantly and the
     fresh fetch runs in the background. 30 min TTL keeps stock visibility honest. */
  var CACHE_TTL = 1800000;
  function cacheKey() { return 'saw3_cache_v2_' + COLLECTION; }
  function readCache() {
    try { var r = localStorage.getItem(cacheKey()); if (!r) return null; var o = JSON.parse(r); if (Date.now() - o.t > CACHE_TTL) return null; return o.p; } catch (e) { return null; }
  }
  function writeCache(prods) {
    /* variants (20 per product) only fed the old quick-add; dropping them keeps the entry ~40% smaller and the
       shared localStorage quota clear for the other scripts on the page */
    var slim = prods.map(function (p) { var q = {}; for (var k in p) if (k !== 'variants' && k !== 'specs') q[k] = p[k]; return q; });
    try { localStorage.setItem(cacheKey(), JSON.stringify({ t: Date.now(), p: slim })); } catch (e) { try { localStorage.removeItem(cacheKey()); } catch (e2) {} }
  }

  var fbtDone = false;   // 2026-08-15: Frequently Bought Together row — opposite-group partners
  function attachFbt() {   // from assets/fbt-map.json keyed by THIS page's collection handle
    if (fbtDone || !fetchComplete) return;
    var fUrl = root.getAttribute('data-fbt-url'), fPage = root.getAttribute('data-page-handle');
    if (!fUrl || !fPage) return;
    fbtDone = true;
    fetch(fUrl).then(function (r) { return r.json(); }).then(function (map) {
      var list = (map && map[fPage]) || [];
      var prods = list.map(function (h) { return allProducts[h]; }).filter(function (p) { return p && (p.totalInv || 0) > 0; });
      var seenStyle = {}, seenColour = {};
      prods = prods.filter(function (p) {
        var sk = styleKeyOf(p), ck = (p.colorName || '').trim().toLowerCase();
        if (seenStyle[sk] || (ck && seenColour[ck])) return false;
        seenStyle[sk] = 1; if (ck) seenColour[ck] = 1; return true;
      });
      if (prods.length < 3) return;
      categories.push({ key: 'Frequently Bought Together', label: 'Frequently Bought Together', slug: 'fbt-row',
        image: prods[0].image || '', group: null, hasTop: false, hasBottom: false, topCount: 0, botCount: 0,
        products: prods, special: 'fbt' });
      renderShells();
      applyGroupVisibility();
      var fRow = document.getElementById('saw-cat-fbt-row-' + SID);
      if (fRow && !qs('.saw-fbt-txtbn', fRow)) {
        fRow.insertAdjacentHTML('afterbegin',
          '<div class="saw-fbt-txtbn"><h2>Frequently <b>Bought</b> Together</h2><p>Customers who bought from this collection <b>also love these</b></p></div>');
      }
    }).catch(function () {});
  }
  function finishRender() {
    /* the grid shows one tile per family, so the single-product 'Explore More' bucket has nothing to add */
    if (LAYOUT === 'grid') {
      categories = categories.filter(function (c) { return c.slug !== EXPLORE_SLUG; });
      /* Tile order: anything launched in the last 60 days leads (newest first), then best sellers — the
         family's best BEST_SELLING position among its colours. Same order inside every toggle. */
      var NEW_MS = 60 * 864e5, now = Date.now();
      categories.forEach(function (c) {
        var newest = 0;
        (c.products || []).forEach(function (p) { if ((p.createdAt || 0) > newest) newest = p.createdAt || 0; });
        c.newest = newest;
        c.isNew = newest > 0 && (now - newest) < NEW_MS;
        c.hasLaunch = (c.products || []).some(function (p) { return p.isLaunch; });
      });
      categories.sort(function (a, b) {
        if (!!a.special !== !!b.special) return a.special ? 1 : -1;
        if (!!a.hasLaunch !== !!b.hasLaunch) return a.hasLaunch ? -1 : 1;   // launch pins lead the grid
        if (a.isNew !== b.isNew) return a.isNew ? -1 : 1;
        if (a.isNew && b.isNew) return b.newest - a.newest;
        return (a.bestRank === undefined ? 1e9 : a.bestRank) - (b.bestRank === undefined ? 1e9 : b.bestRank);
      });
    }
    if (!categories.length) { gridEl.innerHTML = '<div class="saw-loading">No products found in collection.</div>'; return; }
    var previousMax = maxPriceLimit;
    var prices = [];
    categories.forEach(function (c) { c.products.forEach(function (p) { prices.push(p.price); }); });
    if (prices.length) maxPriceLimit = Math.ceil(Math.max.apply(null, prices) / 100) * 100;
    if (filterState.maxPrice === Infinity || filterState.maxPrice === previousMax) filterState.maxPrice = maxPriceLimit;
    var minR = id('saw-price-min-range'), maxR = id('saw-price-max-range'), maxI = id('saw-price-max-input');
    if (minR) minR.max = maxPriceLimit;
    if (maxR) { maxR.max = maxPriceLimit; maxR.value = filterState.maxPrice; }
    if (maxI) maxI.value = filterState.maxPrice;
    if (window['_sawUpdateTrack_' + SID]) window['_sawUpdateTrack_' + SID]();
    renderShells();
    applyGroupVisibility();
    setTimeout(handleSticky, 100);
    setTimeout(syncSpy, 200);
    attachFbt();
  }

  function loadFresh(isBackground) {
    var myReq = reqSeq;                       // token for this fetch
    var raw = [];
    var painted = false;
    // first page is deliberately small: 40 products return much faster than 100 (each carries 20
    // variants + metafields), so real rows replace the skeleton sooner. Remaining pages use 100.
    function page(after, size) {
      /* the section kicks off page 1 inline before this file even arrives — adopt that response once */
      var req = gql(buildQuery(after, size), catalogueController.signal);
      return req.then(function (j) {
        var coll = j && j.data && j.data.collection;
        if (!coll) throw new Error('Catalogue response missing collection');
        var conn = coll.products;
        (conn.edges || []).forEach(function (e) { raw.push(e.node); });
        if (myReq !== reqSeq) return;         // gender changed mid-flight → drop this response
        if (!isBackground && !painted && raw.length) {
          buildCategories(normalizeList(raw));
          if (!urlCatPending()) { painted = true; finishRender(); }   // deep link: keep the skeleton until the target has streamed in
        }
        if (conn.pageInfo && conn.pageInfo.hasNextPage && raw.length < MAX) return page(conn.pageInfo.endCursor, 100);
      });
    }
    return page(null, isBackground ? 100 : 40).then(function () {
      if (myReq !== reqSeq) return;             /* cancelled by the snapshot — never cache a partial list */
      var prods = normalizeList(raw);
      if (!prods.length) return;
      writeCache(prods);                        // cache is keyed per collection, so this is still valid
      if (myReq !== reqSeq) return;             // …but don't paint another gender's products
      fetchComplete = true;
      // Same product count does not mean unchanged prices or stock. Stable row HTML keeps
      // existing images and scroll positions when a background response is identical.
      buildCategories(prods); finishRender();
    }).catch(function (err) {
      if (err.name === 'AbortError' || myReq !== reqSeq) return;
      console.error('SAW', err);
      document.documentElement.classList.remove('saw-deep');
      if (!Object.keys(allProducts).length) {
        var note = document.createElement('p'); note.className = 'saw-loading';
        note.textContent = 'Some products could not load. Reload to try again.';
        gridEl.appendChild(note);
      }
    });
  }

  var SKEL_CARD = '<div><div class="saw-skel-img"></div><div class="saw-skel-line"></div><div class="saw-skel-line short"></div></div>';
  var SKEL_ROWS = (function () {
    var row = '<div class="saw-cat"><div class="saw-skel-head"></div><div class="saw-track">' + SKEL_CARD + SKEL_CARD + SKEL_CARD + SKEL_CARD + '</div></div>';
    return row + row + row;
  })();
  var SKEL_TILES = (function () {
    var t = '<span class="saw-roundel"><span class="saw-roundel-img-wrap"><span class="saw-skel-tile"></span></span><span class="saw-skel-tile-lbl"></span></span>';
    return t + t + t + t + t;
  })();
  var reqSeq = 0;
  var catalogueController = new AbortController();
  var refreshTimer = 0;
  var fetchComplete = false;
  var PRE_KEEP = !!gridEl.querySelector('[data-pre-row]');   /* Liquid prerender stays until the first paint */
  function resetState() {
    catalogueController.abort();
    catalogueController = new AbortController();
    clearTimeout(refreshTimer);
    reqSeq++;
    allProducts = {}; categories = []; activeGroup = LOCK_GROUP || URL_GROUP || null; fbtDone = false;
    filterState = { size: null, colors: [], family: [], minPrice: 0, maxPrice: Infinity };
    maxPriceLimit = 5000; tempFilterSize = []; tempFilterColors = []; tempFilterFamily = []; tfTemp = { fit: [], fabric: [] }; tfSel = { fit: [], fabric: [] }; tempFilterGroup = LOCK_GROUP || null;
    manualLockUntil = 0;
    if (!PRE_KEEP && gridEl) gridEl.innerHTML = SKEL_ROWS;
    var emptyEl = document.getElementById('saw-empty-' + SID); if (emptyEl) emptyEl.style.display = 'none';
    setActiveToggle(); updateFilterLabel();
  }
  /* ── floating bar + popup (FFBAR) ── */
  function ffSync() {
    var sel = filterState.size || [];
    var btn = root.querySelector('[data-saw3-ff-size]');
    if (btn && btn.firstChild) { btn.firstChild.nodeValue = (sel.length ? sel.join(', ') : 'Size') + ' '; btn.classList.toggle('is-active', sel.length > 0); }
    qsa('[data-saw3-ff-g]', root).forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-saw3-ff-g') === ffGender); });
  }
  function ffRefresh() {
    assignCatTogGroups();
    /* the new gender may have nothing in the active pill — fall back to its first pill */
    if (activeCatTog && !catGroupsLive.some(function (g) { return g.label === activeCatTog; })) activeCatTog = catGroupsLive.length ? catGroupsLive[0].label : null;
    renderCatToggles(); updateFilterLabel(); applyGroupVisibility();
  }
  function ffSetGender(g) {
    ffGender = g;
    try { sessionStorage.setItem('saw3_ffg_' + SID, g); } catch (e) {}
    ffSwapUrl(g);
    if (categories.length) ffRefresh(); else ffSync();
  }
  function ffDd(open) {
    var bar = root.querySelector('.saw3-ffbar'); if (!bar) return;
    if (open === undefined) open = !bar.classList.contains('dd-open');
    if (open) {
      var all = {}, sel = filterState.size || [];
      visibleProductsForFilter().forEach(function (p) { if (!ffGender || prodGender(p) === ffGender) (p.sizes || []).forEach(function (z) { all[z] = 1; }); });
      root.querySelector('.saw3-ff-dd-grid').innerHTML = Object.keys(all).sort(function (a, b2) { return (sizeOrderMap[a] || 99) - (sizeOrderMap[b2] || 99); })
        .map(function (z) { return '<button type="button" class="saw3-ff-sz' + (sel.indexOf(z) !== -1 ? ' is-selected' : '') + '" data-saw3-ff-sz="' + z + '">' + z + '</button>'; }).join('') || '<span class="saw3-ff-none">No sizes</span>';
    }
    bar.classList.toggle('dd-open', open);
  }
  if (FFBAR) {
    var ffPop = root.querySelector('.saw3-gpop'), gpG = 'women', gpS = null, ffSaved = null;
    try { ffSaved = sessionStorage.getItem('saw3_ffg_' + SID); } catch (e) {}
    var ffUrlG = FF_PAGES ? ffUrlGender() : '';
    if (FF_ONLY) { var ffGt = root.querySelector('.saw3-ff-gt'); if (ffGt) ffGt.style.display = 'none'; }   // one gender: no Women/Men toggle at all, bar is SIZE | FILTER
    if (ffUrlG) ffGender = ffUrlG;   // sub-pages, Men / Women URL (performance ads): straight in, no popup
    else if (FF_PAGES) {             // sub-pages, the all-gender URL (Shop All Shirts): always ask, last choice preselected
      if (ffSaved) gpG = ffSaved;
      qsa('[data-saw3-gp-g]', root).forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-saw3-gp-g') === gpG); });
      if (ffPop) { ffPop.classList.add('is-visible'); lockBody(); }
    } else if (ffSaved) ffGender = ffSaved;
    else if (ffPop) { ffPop.classList.add('is-visible'); lockBody(); }
    root.addEventListener('click', function (e) {
      var t = e.target, el;
      if (t.closest('[data-saw3-ff-size]')) { ffDd(); return; }
      if ((el = t.closest('[data-saw3-ff-sz]'))) { toggleBarSize(el.getAttribute('data-saw3-ff-sz')); ffSync(); ffDd(false); return; }
      if ((el = t.closest('[data-saw3-ff-g]'))) { ffDd(false); ffSetGender(el.getAttribute('data-saw3-ff-g')); window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
      if ((el = t.closest('[data-saw3-gp-g]'))) { gpG = el.getAttribute('data-saw3-gp-g'); qsa('[data-saw3-gp-g]', root).forEach(function (b) { b.classList.toggle('is-active', b === el); }); return; }
      if ((el = t.closest('[data-saw3-gp-s]'))) { gpS = el.getAttribute('data-saw3-gp-s'); qsa('[data-saw3-gp-s]', root).forEach(function (b) { b.classList.toggle('is-active', b === el); }); return; }
      if (t.closest('[data-saw3-gp-go]')) {
        var err = root.querySelector('.saw3-gpop-err');
        if (!gpS && root.querySelector('[data-saw3-gp-s]')) { if (err) err.textContent = 'Please select a size to continue'; return; }   // size step is optional per template
        if (ffPop) ffPop.classList.remove('is-visible'); unlockBody();
        if (gpS) { filterState.size = [gpS]; tempFilterSize = [gpS]; }
        ffSetGender(gpG);
        return;
      }
      if (!t.closest('.saw3-ffbar')) ffDd(false);
    });
  }
  function loadGender(g) {
    setGenderVars(g);
    resetState();
    if (!COLLECTION) { gridEl.innerHTML = '<div class="saw-loading">No collection set.</div>'; return; }
    var cached = readCache();
    var generation = reqSeq;
    function refreshLater() {
      function schedule() {
        if (generation !== reqSeq) return;
        refreshTimer = setTimeout(function () { if (generation === reqSeq) loadFresh(true); }, 10000);
      }
      if (document.readyState === 'complete') schedule();
      else window.addEventListener('load', schedule, { once: true });
    }
    if (cached && cached.length) { fetchComplete = true; buildCategories(cached); finishRender(); refreshLater(); return; }
    /* static catalogue snapshot (assets/saw3-catalog-<handle>.json, regenerated by scripts/saw3_catalog.py):
       one cached CDN request paints every row at once; the live Storefront fetch then refreshes stock in the background */
    /* Snapshot first; live pagination is the error fallback. Successful snapshots refresh
       stock ten seconds after window load without competing with initial rendering. */
    fetchComplete = false;
    var snap = root.getAttribute('data-catalog-url'); if (!snap) { loadFresh(false); return; }
    var snapT0 = performance.now();
    var snapController = new AbortController();
    var snapTimeout = setTimeout(function () { snapController.abort(); }, 8000);
    fetch(snap, { signal: snapController.signal }).then(function (r) { if (!r.ok) throw new Error('Snapshot HTTP ' + r.status); return r.json(); }).then(function (j) {
      clearTimeout(snapTimeout);
      if (generation !== reqSeq) return;
      var nodes = j && j.nodes;
      window.__saw3Snap = { ms: Math.round(performance.now() - snapT0), n: nodes ? nodes.length : 0, streamingDone: fetchComplete, age_h: j && j.t ? Math.round((Date.now() / 1000 - j.t) / 360) / 10 : null };
      if (!Array.isArray(nodes) || !nodes.length) throw new Error('Empty catalogue snapshot');
      var snapProds = normalizeList(nodes);
      fetchComplete = true; buildCategories(snapProds); finishRender(); writeCache(snapProds);
      refreshLater();
    }).catch(function (e) {
      clearTimeout(snapTimeout);
      if (generation !== reqSeq) return;
      window.__saw3Snap = { error: String(e) };
      loadFresh(false);
    });
  }
  bindToggle();
  setupSlider();
  loadGender('women');
}
document.querySelectorAll('.saw3[data-section]').forEach(function (root) {
  var sid = root.getAttribute('data-section');
  var cfg = (window.__saw3Cfg || {})[sid];
  if (!cfg || root._saw3) return;
  root._saw3 = 1;
  saw3Engine(root, cfg);
});
})();
